const en = {
  // Image validation
  invalidImageFormatSize:
    "Incorrect file format. Please upload an image of type PNG or JPG. Max size (%{fileSize}KB)",
  invalidImageSize: "File size exceeded the max limit of %{fileSize}KB.",
  invalidImageFormat:
    "Incorrect file format. Please upload an image of type PNG or JPG",

  // Common actions
  save: "Save",
  cancel: "Cancel",
  delete: "Delete",
  edit: "Edit",
  add: "Add",
  search: "Search",
  reset: "RESET",
  submit: "Submit",
  confirm: "Confirm",
  close: "Close",
  back: "Back",
  previous: "Previous",
  continue: "Continue",
  next: "Next",
  done: "Done",
  loading: "Loading...",
  enabled: "Enabled",
  disabled: "Disabled",
  actions: "Actions",
  openMenu: "Open menu",
  filters: "Filters",
  pagination: "Pagination",
  breadcrumb: "Breadcrumb",
  download: "Download",
  downloading: "Downloading...",
  duplicate: "Duplicate",
  selectAll: "Select all",
  selectRow: "Select row",
  update: "Update",
  apply: "Apply",
  applyFilters: "Apply Filters",
  remove: "Remove",
  resetAction: "Reset",
  yes: "Yes",
  no: "No",
  or: "or",
  toggleSidebar: "Toggle Sidebar",
  morePages: "More pages",

  trialBanner: {
    daysLeftOne: "1 day left in your Pro trial",
    daysLeft: "%{count} days left in your Pro trial",
    upgrade: "Upgrade",
    trialEndedTitle: "Your Pro trial has ended",
    trialEndedDescription:
      "Upgrade to keep Reports, analytics, and your full team.",
  },

  // Common labels
  name: "Name",
  email: "Email",
  phone: "Phone",
  address: "Address",
  status: "Status",
  amount: "Amount",
  date: "Date",
  type: "Type",
  notes: "Notes",
  viewInvoice: "View Invoice",
  description: "Description",
  total: "Total",
  active: "Active",
  client: "Client",
  project: "Project",
  billable: "Billable",
  nonBillable: "Non-Billable",
  hours: "hours",
  mins: "mins",
  role: "Role",
  country: "Country",
  state: "State",
  city: "City",
  zipcode: "Zipcode",
  currency: "Currency",
  countries: {
    unitedStates: "United States",
  },
  inactive: "Inactive",
  invited: "Invited",
  department: "Department",
  theme: "Theme",
  summary: "Summary",
  format: "Format",
  all: "All",
  from: "From",
  to: "To",
  themeSelector: {
    open: "Open theme selector",
    close: "Close theme selector",
    choose: "Choose Theme",
    description: "Select your preferred interface style",
    classic: "Classic",
    classicDescription: "Traditional Miru interface",
    admin: "Admin Pro",
    adminDescription: "Modern shadcn dashboard",
    minimize: "Minimize",
    previewActive: "Theme preview active",
  },

  // Date/time
  today: "Today",
  yesterday: "Yesterday",
  tomorrow: "Tomorrow",
  weekOf: "Week of",
  thisWeek: "This Week",
  lastWeek: "Last Week",
  thisMonth: "This Month",
  lastMonth: "Last Month",
  thisQuarter: "This Quarter",
  lastQuarter: "Last Quarter",
  thisYear: "This Year",
  lastYear: "Last Year",
  allTime: "All Time",
  customRange: "Custom Range",
  customRangeWithDates: "Custom (%{from} - %{to})",
  customDateRange: "Custom Date Range",
  dateRange: "Date Range",
  dateRangePreset: "Date Range Preset",
  selectDateRange: "Select date range",
  pickADate: "Pick a date",
  pickADateRange: "Pick a date range",
  selectPeriod: "Select period",
  fullDay: "Full Day",
  halfDay: "Half Day",

  // Date validation
  dateCannotBeBlank: "Date can not be blank",
  fromDateMustBeLessThanToDate:
    "'From' date must be less than or equal to 'To' date",
  toDateMustBeGreaterThanFromDate:
    "'To' date must be greater than or equal to 'From' date",
  invalidDate: "Please enter a valid date",

  // Month abbreviations
  monthJan: "Jan",
  monthFeb: "Feb",
  monthMar: "Mar",
  monthApr: "Apr",
  monthMay: "May",
  monthJun: "Jun",
  monthJul: "Jul",
  monthAug: "Aug",
  monthSep: "Sep",
  monthOct: "Oct",
  monthNov: "Nov",
  monthDec: "Dec",

  // Error pages
  pageNotFound: "Page not Found",
  clickHere: "Click here",
  somethingWentWrong: "Something went wrong",
  refreshPageMessage:
    "Refresh the page to try again. If this keeps happening, sign in again or contact support.",
  reloadPage: "Reload page",
  loadingWorkspace: "Loading workspace...",

  // Search
  searchClients: "Search clients...",
  searchInvoices: "Search invoices...",
  searchTeamMembers: "Search team members...",
  selectTeamMember: "Select team member",
  noResultsFound: "No results found",
  dataTable: {
    noResults: "No results.",
    rowsSelected: "%{selected} of %{total} row(s) selected.",
    clearSelection: "Clear selection",
    pageOf: "Page %{page} of %{total}",
  },

  // Time Tracking
  timeTracking: {
    addEntry: "Add Entry",
    newTimeEntry: "New Time Entry",
    editTimeEntry: "Edit Time Entry",
    copyLastWeek: "Copy Last Week",
    copying: "Copying...",
    timeLogged: "Time Logged",
    totalHours: "Total Hours",
    noEntriesForDay: "No time entries for this day yet.",
    noEntriesForDayShort: "No entries for this day",
    selectClient: "Select a client",
    selectProject: "Select a project",
    selectClientFirst: "Select a client first",
    whatDidYouWorkOn: "What did you work on?",
    addNoteHere: "What did you work on? Add your notes here...",
    addANote: "Add a note...",
    timeSpent: "Time Spent",
    saveEntry: "Save Entry",
    savingTo: "Saving To",
    updateEntry: "Update Entry",
    resumeTimer: "Resume timer",
    resume: "Resume",
    editEntry: "Edit entry",
    deleteEntry: "Delete entry",
    editClosed: "Edit closed",
    editWindowClosed: "Editing closed — entry is older than %{days} days",
    deleteTimeEntry: "Delete Time Entry",
    deleteTimeEntryConfirm: "Are you sure you want to delete this time entry?",
    durationRequired: "Duration is required",
    projectRequired: "Project is required",
    duration: "Duration",
    note: "Note",
    noteOptional: "Note (Optional)",
    addTags: "Add Tags",
    favorites: "Favorites",
    favoriteShortcutsHint: "Pin the combinations you use all the time.",
    recentShortcuts: "Recent Shortcuts",
    recentShortcutsHint:
      "Reuse recent work without reselecting the same client and project.",
    saving: "Saving...",
    saveChanges: "Save Changes",
    taskType: "Task Type",
    selectTaskType: "Select task type",
    markTimeOff: "Mark Time Off",
    typeOfTimeOff: "Type of Time Off",
    addAdditionalDetails: "Add any additional details...",
    selectedDay: "Selected Day",
    thisWeek: "This Week",
    weekTotal: "Week Total",
    dayTotal: "Day Total",
    entry: "entry",
    entries: "entries",
    noEntriesForSelectedDay: "No entries for the selected day",
    weekReviewHint:
      "Switch to This Week to review everything you logged this week.",
    noTimeEntriesYet: "No time entries yet",
    firstEntryHint:
      'Click "Add Entry" to log your first time entry for this day',
    logWorkByWeekOrMonth:
      "Log work by week or month. Keep entries clear and current.",
    entriesFor: "Entries for %{name}",
    timeEntriesFor: "Time entries for",
    unableToLoad: "Unable to load time tracking right now.",
    timerResumedFromEntry: "Timer resumed from entry",
    noEntriesInLastWeek: "No entries found in last week.",
    alreadyHasEntries: "This week already has those entries.",
    copiedEntries: "Copied %{count} entries from last week",
    failedToCopyLastWeek: "Failed to copy last week's entries.",
    week: "Week",
    month: "Month",
    holiday: "Holiday",
    leave: "Leave",
    timeOff: "Time off",
    noEntriesToUpdate: "No entries to update",
    entriesUpdatedSuccessfully: "Entries updated successfully",
    failedToUpdateEntries: "Failed to update entries",
    selectProjectFirst: "Please select a project first",
    editingModeActive: "Editing mode is active. Complete your changes above.",
    dayAbbr: {
      mon: "Mon",
      tue: "Tue",
      wed: "Wed",
      thu: "Thu",
      fri: "Fri",
      sat: "Sat",
      sun: "Sun",
    },
  },

  // Task types
  taskTypes: {
    development: "Development",
    meeting: "Meeting",
    research: "Research",
    planning: "Planning",
    testing: "Testing",
    documentation: "Documentation",
    codeReview: "Code Review",
    debugging: "Debugging",
    deployment: "Deployment",
    support: "Support",
    training: "Training",
    other: "Other",
  },

  // Time off types
  timeOffTypes: {
    vacation: "Vacation",
    sickLeave: "Sick Leave",
    personalDay: "Personal Day",
    holiday: "Holiday",
  },

  // Clients
  clients: {
    addClients: "Add Clients",
    addNewClient: "Add New Client",
    editClient: "Edit Client",
    editClientDetails: "Edit Client Details",
    deleteClient: "Delete Client",
    deleteClientConfirm:
      "Are you sure you want to delete client %{name}? This action cannot be reversed.",
    clientDetails: "Client Details",
    clientLogo: "Client logo",
    acceptedPngAndJpgFormats: "Accepted file formats: PNG and JPG.",
    fileSizeLimitKb: "File size should be ≤ %{fileSize} KB.",
    phoneNumber: "Phone number",
    addressLine1: "Address line 1",
    addressLine2: "Address line 2 (optional)",
    selectCountry: "Select country...",
    selectCurrency: "Select currency...",
    totalClients: "Total Clients",
    activeClients: "Active clients",
    hoursTracked: "Hours Tracked",
    hoursLogged: "Hours Logged",
    totalTracked: "Total tracked",
    outstanding: "OUTSTANDING",
    overdue: "OVERDUE",
    allClients: "All Clients",
    allClientsDescription:
      "A list of all your clients with their contact information and billing status.",
    failedToLoadClients: "Failed to load clients",
    failedToLoadClientDetails: "Failed to load client details",
    clientDeletedSuccessfully: "Client deleted successfully",
    failedToDeleteClient: "Failed to delete client",
    clientAddedSuccessfully: "Client added successfully",
    clientUpdatedSuccessfully: "Client updated successfully",
    noClientsYet: "Looks like there aren't any clients added yet.",
    viewingMatchingClients:
      "Viewing %{filtered} matching client(s) from %{total} loaded",
    deleting: "Deleting...",
    addYourFirstClient: "Add Your First Client",
    addNewClientDescription: "Fill in the details below to add a new client.",
    editClientDescription: "Update the client details below.",
    manageClientsDescription: "Manage your client relationships and billing",
    clientHeader: "CLIENT",
    contact: "Contact",
    copyClientId: "Copy client ID",
    viewDetails: "View details",
    addProject: "Add Project",
    addNewProject: "Add New Project",
    paymentReminder: "Payment Reminder",
    addOrViewContacts: "Add / View Contacts",
    sendPaymentReminder: "Send Payment Reminder",
    paymentReminderSubject: "Reminder to complete payments for unpaid invoices",
    paymentReminderMessage:
      "This is a gentle reminder to complete payments for the following invoices. You can find the respective payment links along with the invoice details given below",
    selectInvoices: "Select invoices",
    emailPreview: "Email preview",
    recipientEmailId: "Recipient Email ID",
    invoiceSelected: "%{count} invoice selected",
    invoicesSelected: "%{count} invoices selected",
    noProjectsAddedYet: "No project has been added to this client yet.",
    includeSignatureOnInvoices: "Include signature on invoices",
    includeSignatureOnInvoicesDescription:
      "When enabled, the company signature will appear on invoices for this client.",
  },

  // Contacts
  contacts: {
    addContact: "Add Contact",
    addContacts: "Add Contacts",
    editContact: "Edit Contact",
    deleteContact: "Delete Contact",
    deleteContactConfirm:
      "Are you sure you want to delete contact %{name}? This action cannot be reversed.",
    firstName: "First Name",
    lastName: "Last Name",
    updateContact: "Update Contact",
    firstNameOnlyLetters: "First Name must contain only letters",
    lastNameOnlyLetters: "Last Name must contain only letters",
    maxCharacters: "Maximum 20 characters are allowed",
    firstNameRequired: "First Name cannot be blank",
    lastNameRequired: "Last Name cannot be blank",
    invalidEmailId: "Invalid email ID",
    emailRequired: "Email ID cannot be blank",
  },

  // Projects
  projects: {
    addProject: "Add project",
    addNewProject: "Add new project",
    editProject: "Edit project",
    deleteProject: "Delete project",
    deleteProjectConfirm:
      "Remove %{name} from your workspace. This action cannot be reversed.",
    projectName: "Project name",
    enterProjectName: "Enter project name",
    selectClient: "Select client",
    projectType: "Project type",
    projectClient: "PROJECT/CLIENT",
    noClient: "No Client",
    hoursLogged: "HOURS LOGGED",
    totalHours: "Total Hours",
    teamMembers: "Team Members",
    team: "Team",
    allProjects: "All Projects",
    allProjectsDescription: "Manage your projects and track progress",
    failedToLoadProjects: "Failed to load projects",
    failedToDeleteProject: "Failed to delete project",
    projectDeletedSuccessfully: "Project deleted successfully",
    viewDetails: "View details",
    copyProjectId: "Copy project ID",
    manageProjectsDescription: "Manage your projects and track progress",
    newProject: "New Project",
    activeProjects: "Active Projects",
    ofTotalProjects: "of %{count} total projects",
    trackedAcrossAllProjects: "Tracked across all projects",
    more: "more",
    searchProjects: "Search projects...",
    createFirstProject: "Create your first project to get started.",
    noProjectsYet: "No projects yet",
    viewingMatchingProjects:
      "Viewing %{filtered} matching project(s) from %{total} loaded",
    workingOnProjects:
      "Track billable and non-billable work across your projects.",
    active: "Active",
    paused: "Paused",
    completed: "Completed",
    unknown: "Unknown",
    newInvoice: "New invoice",
    manageTeam: "Manage team",
    manageProjectMembers: "Manage project members",
    teamMember: "Team member",
    selectTeammate: "Select teammate",
    hourlyRate: "Hourly rate",
    cost: "COST",
    overdue: "OVERDUE",
    outstanding: "OUTSTANDING",
    deleting: "Deleting...",
    createProject: "Create project",
    createProjectDescription: "Set up a new project and assign it to a client.",
    editProjectDetails: "Edit Project Details",
    saveChanges: "Save Changes",
    billableDescription: "Track time and bill the client for this project",
    nonBillableDescription: "Track time without billing the client",
    noClientsPresent: "No clients present",
    teamMembersUpdated: "Team members updated successfully",
    manageProjectMembersDescription:
      "Add or remove team members and set their hourly rates.",
    enterValidRate: "Please enter a valid rate",
    addAnotherTeamMember: "Add Another Member",
    addTeamMember: "Add Team Member",
    saveTeamMembers: "Save Members",
    noTeamMembersAdded: "No team members have been added yet.",
    addTeamMembers: "Add Team Members",
    teamMembersDescription:
      "View and manage team members assigned to this project.",
  },

  // Team
  team: {
    team: "Team",
    teamOverview: "Team Overview",
    totalMembers: "Total Members",
    inviteMember: "Invite Member",
    resendInvite: "Resend Invite",
    editMember: "Edit Member",
    deleteUser: "Delete User",
    deleteInvite: "Delete Invite",
    deleteUserConfirm:
      "Are you sure you want to delete user %{name}? This action cannot be reversed.",
    deleteImpact: {
      warningTitle: "Warning: This member has active work in this workspace.",
      assignedProjects: {
        one: "Assigned to %{count} project%{projectNames}",
        other: "Assigned to %{count} projects%{projectNames}",
      },
      unbilledHours: {
        one: "%{hours} unbilled hours across %{count} entry (estimated value: $%{amount})",
        other:
          "%{hours} unbilled hours across %{count} entries (estimated value: $%{amount})",
      },
      noBilledEntries: "No billed entries found for this member.",
    },
    admin: "Admin",
    employee: "Employee",
    bookkeeper: "Bookkeeper",
    clientRole: "Client",
    owner: "Owner",
    salary: "SALARY",
    user: "USER",
    failedToLoadTeamMembers: "Failed to load team members",
    noTeamMembersYet: "No team members yet",
    viewingMatchingMembers:
      "Viewing %{filtered} matching member(s) from %{total} loaded",
    totalHours: "Total Hours",
    billableHours: "Billable hours",
    usersPerPage: "users/page",
    removing: "Removing...",
    invalidLink: "The link is not valid",
    checkWithAdmin: "Please check with the Administrator",
    login: "Login",
    upgradePlan: "Upgrade to add more members",
    activeProjects: "Active Projects",
    acrossAllMembers: "Across all members",
    avgUtilization: "Avg. Utilization",
    copyEmail: "Copy email",
    viewProfile: "View profile",
    position: "Position",
    currentProjects: "Current Projects",
    nMore: "+%{count} more",
    seatLimitReached:
      "Free workspaces are limited to 3 team seats. Upgrade to Pro to invite more members.",
    firstNameLettersOnly: "First Name must contain only letters",
    lastNameLettersOnly: "Last Name must contain only letters",
    maxCharacters: "Maximum %{count} characters are allowed",
    firstNameRequired: "First Name cannot be blank",
    lastNameRequired: "Last Name cannot be blank",
    invalidEmail: "Invalid email ID",
    emailRequired: "Email ID cannot be blank",
    permanentlyDeleteUser: "Permanently Delete User",
    permanentlyDeleteUserConfirm:
      "This will permanently delete the user account and all associated data. This action cannot be undone.",
    typeEmailToConfirm: "Type the user's email address to confirm:",
    permanentlyDeleting: "Deleting...",
  },

  // Invoices
  invoices: {
    invoice: "Invoice",
    invoices: "Invoices",
    generateInvoice: "Generate Invoice",
    editInvoice: "Edit Invoice #%{number}",
    createNewInvoice: "Create New Invoice",
    deleteInvoice: "Delete Invoice",
    deleteInvoices: "Delete Invoices",
    deleteInvoiceConfirm:
      "Are you sure you want to delete this invoice? This action cannot be reversed.",
    deleteInvoicesConfirm:
      "Are you sure you want to delete these invoices? This action cannot be reversed.",
    waiveOffInvoice: "Waive Off Invoice",
    waiveOffConfirm:
      "Are you sure you want to waive off invoice %{number}? This action cannot be reversed.",
    waiveOff: "Waive Off",
    markAsPaid: "Mark as Paid",
    markInvoiceAsPaid: "Mark Invoice As Paid",
    sendInvoice: "Send Invoice",
    sendInvoiceNumber: "Send Invoice #%{number}",
    sendReminder: "Send Reminder",
    sendInvoiceReminder: "Send Invoice Reminder",
    viewHistory: "View History",
    history: "History",
    settings: "Settings",
    invoiceNumber: "Invoice Number",
    invoiceNo: "INVOICE NO.",
    clientInvoiceNo: "CLIENT / INVOICE NO.",
    issueDate: "Issue Date",
    issuedDate: "ISSUED DATE",
    issueDateDueDate: "ISSUED DATE / DUE DATE",
    dueDate: "Due Date",
    reference: "Reference",
    poNumberPlaceholder: "PO Number, etc.",
    selectAClient: "Select a client",
    billedTo: "Billed to",
    dateOfIssue: "Date of Issue",
    basicDetails: "Basic Details",
    lineItems: "Line Items",
    additionalDetails: "Additional Details",
    taxDiscountNotes: "Tax, discount, and notes",
    discount: "Discount",
    tax: "Tax",
    taxConfigurations: "Tax configurations",
    additionalNotesPlaceholder: "Additional notes or payment instructions",
    enterName: "Enter name",
    enterNameTooltip: "Enter the name for this line item",
    selectDate: "Select Date",
    deleteLineItem: "Delete this line item",
    enterDescription: "Enter Description",
    descriptionTooltip: "Add detailed description for this line item",
    rate: "Rate",
    quantity: "Quantity",
    selectTimeEntries: "Select Time Entries",
    groupByProject: "Group by project",
    entriesSelected: "%{count} entries selected",
    resetSelectedEntries: "Reset Selected Entries",
    addEntries: "ADD ENTRIES",
    addEntry: "Add %{count} entry",
    addEntries_plural: "Add %{count} entries",
    thankYouForBusiness: "Thank you for your business!",
    previewNote: "This is a preview. Changes will be reflected once saved.",
    noInvoiceGenerated: "No invoice has been generated yet.",
    acceptCreditCards: "Accept Credit Cards",
    sendTo: "SEND TO",
    send: "SEND",
    recentlyUpdated: "Recently Updated",
    sortedByLatestUpdate: "Sorted by latest update time",
    noRecentlyUpdated: "No recently updated invoices",
    allCaughtUp: "All caught up!",
    failedToLoad: "Failed to load",
    scrollForMore: "Scroll for more",
    scrollToLoadMore: "Scroll to load more invoices",
    loadingMoreInvoices: "Loading more invoices...",
    allInvoicesLoaded: "All invoices loaded",
    showingOfTotal: "Showing %{shown} of %{total}",
    resetFilters: "Reset filters",
    loadingChartData: "Loading chart data...",
    noInvoiceData: "No invoice data available",

    // Statuses
    draft: "Draft",
    sent: "Sent",
    overdue: "Overdue",
    collected: "Collected",
    paid: "Paid",
    unpaid: "Unpaid",
    outstanding: "Outstanding",

    // Email
    recipientEmailId: "Recipient Email ID",
    subject: "Subject",
    message: "Message",
    addEmailFromClientSettings: "Please add email from client settings page",
    reminderSubject: "Reminder to complete payments for unpaid invoice",
    invoiceSentSubject: "%{company} sent you an invoice (%{number})",
    reminderBody: "%{company} has sent you a reminder for invoice %{number}",
    invoiceSentBody: "%{company} has sent you an invoice (%{number})",
    invoiceWillBeSent: "Invoice will be sent!",
    processing: "processing...",

    // No payment gateway
    noPaymentGateway: "No payment gateway connected",
    paymentGatewayError:
      "Error. Please reach out to the invoice sender to connect a payment gateway to enable you to make invoice payment",
    paymentGatewayWarning:
      "Connect Razorpay for Indian cards and UPI, or add a free UPI QR before sending this invoice.",
    goToPaymentSettings: "Set Up Payments",
    backToInvoices: "Back to Invoices",
    sendWithoutPaymentGateway: "Send Without Payment Gateway",
    paymentSetupPromptTitle: "Get paid faster on invoices",
    paymentSetupPromptDescription:
      "Set up Razorpay Payment Links for Indian cards, UPI, wallets, and netbanking, or add a free UPI QR for direct transfers.",
    razorpayCardsAndUpi: "Razorpay cards + UPI",
    freeUpiQr: "Free UPI QR",
    paymentLinksAndWebhooks: "Auto reconciliation",
    setUpRazorpay: "Set up Razorpay",
    stripeDisabled: "Stripe disabled for this invoice",
    stripeDisabledMessage:
      "The sender hasn't enabled Stripe payments for this invoice. You can reach out to them to activate it, or choose an alternative payment method like ACH.",

    // Bulk actions
    preparingDownload: "Preparing download...",
    downloadFailed: "Download failed. Please try again.",
    downloadingFiles: "Downloading files...",
    downloadComplete: "Download Complete",

    // Table headers
    nameHeader: "NAME",
    descriptionHeader: "DESCRIPTION",
    dateHeader: "DATE",
    timeHeader: "TIME",
    amountHeader: "AMOUNT",
    statusHeader: "STATUS",
    invoiceNumberHeader: "INVOICE NUMBER",

    // Chart labels
    area: "Area",
    bar: "Bar",
    noData: "No data",
    monthly: "Monthly",
    quarterly: "Quarterly",
    yearly: "Yearly",
    trend: "Trend",

    // Preview / detail labels
    taxId: "Tax ID: %{value}",
    vatNumber: "VAT Number: %{value}",
    gstNumber: "GST Number: %{value}",
    ein: "EIN: %{value}",
    usTaxpayerId: "U.S. Taxpayer ID: %{value}",
    bankDetails: "Bank Details",
    bankName: "Bank Name: %{value}",
    accountNumber: "Account Number: %{value}",
    routingNumber: "Routing Number: %{value}",
    swiftCode: "SWIFT Code: %{value}",
    overdueDays: "Overdue by %{days} days",
    paidOn: "Paid on %{date}",
    due: "Due %{date}",
    viewed: "Viewed",
    cancelled: "Cancelled",

    // Toast / confirmation messages
    invoiceMarkedAsPaid: "Invoice marked as paid successfully",
    invoiceDownloaded: "Invoice downloaded successfully",
    invoiceSentSuccessfully: "Invoice sent successfully",
    reminderSentSuccessfully: "Reminder sent successfully",
    failedToDownload: "Failed to download invoice",
    failedToSend: "Failed to send invoice. Please try again.",
    cannotDownloadPreview: "Cannot download preview invoice",
    cannotSendPreview: "Cannot send preview invoice",
    cannotEditPreview: "Cannot edit preview invoice",
    sendInvoiceFailed: "Send invoice failed",
    failedToLoadRevenueData: "Failed to load revenue data",
    errorConnectingPayments: "Error connecting to payments",
    invoiceCreated: "Invoice created successfully",
    invoiceUpdated: "Invoice updated successfully",
    failedToSaveInvoice: "Failed to save invoice. Please try again.",
    newInvoicePage: "New invoice",
    editInvoicePage: "Edit invoice",
    editorSubtitle:
      "Fill in the details and preview the invoice before sending it.",
    basicDetailsDescription: "Enter the basic invoice information",
    referenceOptional: "Reference (Optional)",
    referencePlaceholder: "PO Number, etc.",
    lineItemsDescription: "Add time entries or manual items",
    additionalDetailsDescription: "Tax, discount, and notes",
    notesPlaceholder: "Additional notes or payment instructions",
    subtotal: "Subtotal",
    saving: "Saving...",
    sending: "Sending...",
    alreadySent: "Already sent",
    downloading: "Downloading...",
    selectClientBeforeSending: "Select a client before sending the invoice.",

    // Counters
    showingOf: "Showing %{shown} of %{total}",
    viewingMatching:
      "Viewing %{filtered} matching invoice(s) from %{loaded} loaded",
    loadedOf: "Loaded %{loaded} of %{total}",
    showingRecentTransactions: "Showing %{count} recent transactions",
    updatedAt: "Updated %{date}",
    invoiceHash: "Invoice #%{number}",

    // Mobile table headers
    nameDescription: "NAME / DESCRIPTION",
    dateTime: "DATE / TIME",

    // Invoice reminder email
    invoiceReminder: "Invoice Reminder: %{number}",
    reminderMessage:
      "This is a reminder about your outstanding invoice. Please find the details attached.",
    invoiceAttached: "Please find your invoice attached.",
    reminderPaymentMessage:
      "This is a reminder about your overdue invoice. Please complete payment.",
    invoiceSubject: "Invoice %{number}",
    reminderPaymentSubject:
      "Reminder to complete payment for invoice %{number}",
    markAsPaidConfirm:
      "Mark this invoice as paid? This action affects accounting records.",
    failedToLoadInvoice: "Failed to load invoice",
    invoiceNotFound: "Invoice not found",
    failedToMarkAsPaid: "Failed to mark invoice as paid",
    failedToDownloadInvoice: "Failed to download invoice",
    cannotDownloadInvalidId: "Cannot download invoice - invalid ID",
    cannotSendInvalidId: "Cannot send invoice - invalid ID",
    payment: "Payment #%{id}",
  },
  // Invoice admin dashboard
  invoiceDashboard: {
    revenueOverview: "Revenue Overview",
    revenueByStatus: "Revenue by Status",
    recentActivity: "Recent Activity",
    allInvoices: "All Invoices",
    recentSales: "Recent Sales",
  },

  // Payments
  payments: {
    payments: "Payments",
    addPayment: "Add Payment",
    addManualEntry: "ADD MANUAL ENTRY",
    searchPaymentsPlaceholder:
      "Search payments by client, invoice, or amount...",
    noPaymentsRecorded: "No payments have been recorded yet",
    invoiceClient: "INVOICE # / CLIENT",
    clientInvoiceNumber: "CLIENT/ INVOICE NUMBER",
    dateType: "DATE / TYPE",
    statusAmount: "STATUS/ AMOUNT",
    paymentSearch: "Search",
    invoice: "Invoice",
    transactionDate: "Transaction Date",
    transactionType: "Transaction Type",
    selectTransactionType: "Select transaction type...",
    paymentAmount: "Payment amount",
    notesOptional: "Notes (optional)",
    paymentSuccessful: "Payment was successful.",
    paymentReceived: "We have received your payment.",
    goToHomePage: "Go To Home Page",
    recordManualPaymentAgainstInvoice:
      "Record a manual payment against an invoice.",
    failedToLoadPayments: "Failed to load payments",
    failedToLoadInvoicesForPaymentEntry:
      "Failed to load invoices for payment entry",
    transactions: "Transactions",
    totalPayments: "Total Payments",
    totalCollected: "Total Collected",
    allTime: "All time",
    averagePayment: "Average Payment",
    perTransaction: "Per transaction",
    paymentHistory: "Payment History",
    paymentHistoryDescription: "Every payment with invoice and client details.",
    paymentLedgerDescription: "Stripe and manual entries in one simple ledger.",
    searchByInvoiceClientMethodOrNotes:
      "Search by invoice, client, method, or notes...",
    showingPaymentsCount: "Showing %{visible} of %{total}",
    viewingMatchingPayments:
      "Viewing %{filtered} matching payment(s) from %{total} loaded",
    notes: "Notes",
    paymentMethod: "Payment Method",
    withdrawal: "Withdrawal",
    openMenu: "Open menu",
    copyTransactionId: "Copy transaction ID",
    copyTransactionIds: "Copy transaction IDs",
    transactionIdsCopied: "%{count} transaction ID(s) copied.",
    transactionIdsCopyFailed: "Failed to copy transaction IDs.",
    downloadSelected: "Download selected",
    bulkDownloadSuccess: "%{count} payment(s) exported successfully.",
    bulkDownloadFailed: "Failed to download selected payments.",
    viewInvoice: "View invoice",
    downloadReceipt: "Download receipt",
    downloadReceiptFailed: "Failed to download receipt.",
    withdrawToUpi: "Withdraw to UPI",
    retryWithdrawal: "Retry withdrawal",
    withdrawing: "Withdrawing...",
    razorpayWithdrawalQueued: "Razorpay withdrawal queued.",
    razorpayWithdrawalFailed: "Failed to create Razorpay withdrawal.",
    notWithdrawn: "Not withdrawn",
    withdrawalPending: "Pending",
    withdrawalProcessing: "Processing",
    withdrawalQueued: "Queued",
    withdrawalProcessed: "Processed",
    withdrawalFailed: "Failed",
    withdrawalReversed: "Reversed",
    withdrawalCancelled: "Cancelled",
    manual: "Manual",
    visa: "Visa",
    mastercard: "Mastercard",
    amex: "Amex",
    debitCard: "Debit Card",
    creditCard: "Credit Card",
    scrollToLoadMore: "Scroll to load more payments",
    allPaymentsLoaded: "All payments loaded",

    // Filters
    allStatuses: "All Statuses",
    allClients: "All Clients",
    paymentType: "Payment Type",
    allTypes: "All Types",
    cardPayment: "Card Payment",
    bankTransfer: "Bank Transfer",
    upi: "UPI",
    wireTransfer: "Wire Transfer",
    achTransfer: "ACH Transfer",
    paypal: "PayPal",
    stripe: "Stripe",
    razorpay: "Razorpay",
    cash: "Cash",
    check: "Check",
    paid: "Paid",
    partiallyPaid: "Partially Paid",
    pending: "Pending",
    failed: "Failed",
    cancelled: "Cancelled",
    refunded: "Refunded",
    completed: "Completed",
    addPaymentBtn: "ADD PAYMENT",
    manualEntryAdded: "Manual entry added successfully.",
    failedToAddManualEntry: "Failed to add manual entry",
    searchByClientOrInvoice: "Search by client name or invoice ID",
    noInvoicesAvailable: "No invoices available",
    createInvoiceFirstToAddPayment: "Create an invoice first to add a payment",
    selectTransactionTypeBtn: "Select Transaction Type",
    noPaymentFound: "No payment found!",
  },

  // Timer
  timer: {
    webTimer: "Web timer",
    webTimerLabel: "Web Timer",
    trackLiveWork:
      "Track live work in real time. Web and MiruTime stay in sync for the active workspace.",
    startTimer: "Start Timer",
    pause: "Pause",
    resume: "Resume",
    start: "Start",
    stop: "Stop",
    reset: "Reset",
    timer: "Timer",
    timerDeck: "Timer deck",
    switchTimer: "Switch timer",
    newTimer: "New timer",
    untitledTimer: "Untitled timer",
    activeTimers: "%{count} active",
    localTimer: "Local timer",
    sharedWithDesktop: "Shared with MiruTime",
    saveTimeEntry: "Save Time Entry",
    saveTimeEntryDescription:
      "You tracked %{time}. Would you like to save this as a time entry?",
    discard: "Discard",
    timerStarted: "Timer started",
    timerPaused: "Timer paused",
    timerReset: "Timer reset",
    durationAtLeastOneMinute: "Duration must be at least 1 minute",
    timeEntrySavedSuccessfully: "Time entry saved successfully",
    failedToSaveTimeEntry: "Failed to save time entry",
    whatAreYouWorkingOn: "What are you working on?",
    selectProject: "Select project",
  },

  // Reports
  reports: {
    reports: "Reports",
    backToReports: "Back to Reports",
    timeReports: "Time Reports",
    hoursAndTime: "Hours and time",
    readyToRun: "Ready to run",
    allReports: "All Reports",
    time: "Time",
    financial: "Financial",
    comingSoon: "Coming Soon",
    quickActions: "Quick Actions",
    exportAsCsv: "Export as CSV",
    exportAsPdf: "Export as PDF",
    toggleReportFilters: "Toggle report filters",

    // Filters
    clients: "Clients",
    teamMembers: "Team Members",
    groupBy: "Group By",
    groupByClient: "Group by Client",
    groupByProject: "Group by Project",
    searchClientsFilter: "Search Clients...",
    searchTeamMembersFilter: "Search Team Members...",
    applyFilter: "Apply Filter",

    // Time entry report
    totalHours: "Total Hours",
    scrollToLoadMoreRows: "Scroll to load more report rows",
    loadingMoreRows: "Loading more report rows...",
    allRowsLoaded: "All report rows loaded",

    // Payment report
    perTransaction: "Per transaction",
    topMethod: "Top Method",
    paymentMethodsBreakdown: "Payment Methods Breakdown",
    paymentDetails: "Payment Details",
    unableToLoadPaymentReport: "Unable to load payment report",
    totalPayments: "Total Payments",
    paymentCount: "Payment Count",
    averagePayment: "Average Payment",
    totalTransactions: "Total transactions",
    selectedPeriod: "Selected period",
    noPaymentsFoundForSelectedPeriod:
      "No payments found for the selected period.",
    showingPayments: "Showing %{shown} of %{total} payments",
    scrollToLoadMorePayments: "Scroll to load more payments",
    clientsSelected: "%{count} clients",
    paymentMethod: "Payment Method",
    allMethods: "All Methods",
    creditCard: "Credit Card",
    allStatus: "All Status",

    // Revenue by client report
    totalRevenue: "Total Revenue",
    paidRevenue: "Paid Revenue",
    paidAmount: "Paid Amount",
    overdueAmount: "Overdue Amount",
    outstandingAmount: "Outstanding Amount",
    acrossClients: "Across clients",
    collected: "Collected",
    pastDue: "Past due",
    withRevenue: "With revenue",
    searchClients: "Search Clients",
    filterClients: "Filter clients...",
    columns: "Columns",
    clientName: "Client Name",
    invoices: "Invoices",
    revenueBreakdown: "Revenue Breakdown",
    detailedRevenueAnalysis: "Detailed revenue analysis by client",
    clientRevenueDetails: "Client Revenue Details",
    scrollToLoadMoreClients: "Scroll to load more clients",
    allClientsLoaded: "All clients loaded",
    clearClients: "Clear clients",
    successfullyCollected: "Successfully collected",
    pendingCollection: "Pending collection",
    requiresAttention: "Requires attention",
    revenueMixByClient: "Revenue Mix by Client",
    noClientRevenueData:
      "No client revenue data available for the selected filters.",
    paid: "Paid",
    awaitingPayment: "Awaiting payment",

    // Outstanding invoice report
    failedToLoadReportData: "Failed to load report data",
    currencyFilter: "Currency Filter",
    fromDate: "From Date",
    toDate: "To Date",
    export: "Export",
    csv: "CSV",
    pdf: "PDF",
    excel: "Excel",
    statusOverview: "Status Overview",
    agingDistribution: "Aging Distribution",
    currencyDistribution: "Currency Distribution",
    topClients: "Top Clients",
    clientAnalysis: "Client Analysis",
    paymentBehavior: "Payment Behavior",
    overdueDetails: "Overdue Details",
    clientBreakdown: "Client Breakdown",
    originalAmount: "Original Amount",
    baseAmount: "Base Amount",

    // Accounts aging report
    totalDue: "Total Due",
    invoiceAgingDetails: "Invoice Aging Details",
    noDataFound: "No Data Found",
    accountsAgingReport: "Accounts Aging Report",
    analysisOfOutstandingReceivables:
      "Analysis of outstanding receivables by aging period",
    asOf: "As of %{date}",
    zeroToThirtyDays: "0-30 Days",
    thirtyOneToSixtyDays: "31-60 Days",
    sixtyOneToNinetyDays: "61-90 Days",
    sixtyPlusDays: "60+ Days",
    ninetyPlusDays: "90+ Days",
    noClientsWithOutstandingBalances: "No clients with outstanding balances.",
    showingOfClients: "Showing %{displayed} of %{total} clients...",
    loadMore: "Load more",
    errorLoadingReportData: "Error loading report data. Please try again.",
    projectClient: "PROJECT/ CLIENT",
    noteHeader: "NOTE",
    teamMemberDate: "TEAM MEMBER/ DATE",
    hoursLogged: "HOURS LOGGED",
    noResultsMatchFilters:
      "No results match current filters. Try removing some filters.",
    noTimeEntriesYet:
      "There are no time entries added yet. You'll see a summary of time entries added by your team.",
    selected: "%{count} selected",
    showingClientsCount: "Showing %{shown} of %{total} clients",
    ofTeamMembersSelected: "%{active} of %{total} team members selected",
    statusGuide: "Status Guide:",
    activeCount: "%{count} active",
    noGrouping: "No Grouping",
    byClient: "By Client",
    byProject: "By Project",
    byTeamMember: "By Team Member",
    byDate: "By Date",
    byWeek: "By Week",
    byMonth: "By Month",
    showAllEntries: "Show all entries",
    groupByClientName: "Group by client name",
    groupByProjectDesc: "Group by project",
    groupByAssignee: "Group by assignee",
    groupByDate: "Group by date",
    groupByWeek: "Group by week",
    groupByMonth: "Group by month",
    previewLabel: "Preview:",
    entriesWillBeGrouped: "Entries will be grouped %{grouping}",
    subtotalsShownForEachGroup: "Subtotals will be shown for each group",
    timeEntryReportTitle: "Time Entry Report",
    timeEntryReportDesc: "A summary of the time entries added by your team.",
    invoicesReport: "Invoices Report",
    invoicesReportDesc:
      "A detailed summary of outstanding and overdue of all clients for a period of time.",
    totalHoursLoggedTitle: "Total hours logged",
    totalHoursLoggedDesc:
      "A detailed summary of billed, unbilled and non-billable hours by team grouped by project.",
    revenueReport: "Revenue Report",
    revenueReportDesc: "A detailed report of revenue from each client.",
    accountsAging: "Accounts Aging",
    accountsAgingDesc:
      "Find out which client have been taking a long time to pay",
    clearAll: "CLEAR ALL",
    outstandingAndOverdue: "Outstanding and Overdue",
    followUpOnInvoices: "Follow up on invoices that still need attention.",
    outstanding: "Outstanding",
    overdue: "Overdue",
    refresh: "Refresh",
    applyDateFilter: "Apply Date Filter",
    totalOutstanding: "Total Outstanding",
    totalOverdue: "Total Overdue",
    totalInvoices: "Total Invoices",
    totalAmount: "Total Amount",
    exportSection: "Export",
    formatLabel: "Format",
    exportPdfBtn: "Export PDF",
    exportCsvBtn: "Export CSV",
    noOutstandingOrOverdueInvoices: "No outstanding or overdue invoices found.",
    allCurrencies: "All currencies",
    filteredByCurrency: "Filtered by %{currency}",
    overdueAgingTitle: "Overdue Aging (%{currency})",
    averageDays: "Average Days:",
    timeReportsDesc:
      "A comprehensive summary of time entries added by your team members",
    outstandingOverdueInvoicesTitle: "Outstanding & Overdue Invoices",
    outstandingOverdueInvoicesDesc:
      "Detailed overview of outstanding and overdue invoices across all clients",
    revenueByClient: "Revenue by Client",
    revenueByClientDesc:
      "Revenue breakdown by client with trends and comparisons",
    accountsAgingTableDesc:
      "Age analysis of outstanding receivables by time period",
    paymentReportTitle: "Payment Report",
    paymentReportDesc:
      "Track all payments received with detailed transaction history",
    teamUtilization: "Team Utilization",
    teamUtilizationDesc: "Team member utilization rates and capacity analysis",
    projectProfitability: "Project Profitability",
    projectProfitabilityDesc:
      "Profitability analysis by project with cost breakdown",
    clientSummaryTitle: "Client Summary",
    clientSummaryDesc:
      "Comprehensive client performance and engagement metrics",
    understandReportsAtGlance:
      "Understand revenue, time, and outstanding work at a glance.",
    scheduleReports: "Schedule reports",
    availableReports: "Available Reports",
    revenueAndBilling: "Revenue and billing",
    recentlyViewed: "Recently Viewed",
    lastSevenDays: "Last 7 Days",
    commonReportingTasks: "Common reporting tasks and shortcuts",
    generateWeeklyTimesheet: "Generate Weekly Timesheet",
    viewOverdueInvoices: "View Overdue Invoices",
    monthlyRevenueReport: "Monthly Revenue Report",
    openReport: "Open %{title} report",
    reviewHoursLogged: "Review hours logged by person, client, and project.",
    shareReport: "Share report",
    linkCopied: "Link copied",
    lastSevenDaysPreset: "Last 7 Days",
    lastThirtyDaysPreset: "Last 30 Days",
    totalEntries: "Total Entries",
    timeEntriesRecorded: "Time entries recorded",
    activeClients: "Active Clients",
    activeProjects: "Active Projects",
    activeTeamMembers: "Active Team Members",
    withRecordedTime: "With recorded time",
    noResults: "No results.",
    loadedPages: "Loaded %{loaded} of %{total} report pages",
    totalLabel: "Total:",
    clientHeader: "Client",
    dateHeader: "Date",
    teamMemberHeader: "Team Member",
    projectHeader: "Project",
    noteColumnHeader: "Note",
    hoursHeader: "Hours",
    invoiceHeader: "Invoice",
    mustIncludeFromDate: "Must include From date",
    mustIncludeToDate: "Must include To date",
    dataRefreshed: "Data refreshed",
    exportStarted: "Export started",
    unknownClient: "Unknown Client",
    unknownUser: "Unknown User",
    unknownProject: "Unknown Project",
    generatingExport: "Generating %{format}",
  },

  // Expenses
  expenses: {
    expenses: "Expenses",
    addExpense: "Add Expense",
    newExpense: "New Expense",
    editExpense: "Edit Expense",
    deleteExpense: "Delete Expense",
    deleteExpenseConfirm:
      "Are you sure you want to delete this expense? This action cannot be reversed.",
    deleteExpenseConfirmUndone:
      "Are you sure you want to delete this expense? This action cannot be undone.",
    expenseDetails: "Expense Details",
    category: "Category",
    selectCategory: "Select category",
    selectCategoryEllipsis: "Select category...",
    customCategory: "Custom Category",
    enterCustomCategory: "Enter custom category",
    vendor: "Vendor",
    enterVendor: "Enter vendor",
    enterVendorName: "Enter vendor name",
    receipt: "Receipt",
    receiptOptional: "Receipt (optional)",
    receipts: "Receipts",
    receiptsAttached: "%{count} attached",
    preview: "Preview",
    uploadReceipt: "Upload receipt",
    uploadFile: "Upload file",
    noExpenses: "No expenses found",
    noExpensesRecorded: "No expenses recorded",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    submitted: "Submitted",
    paid: "Paid",
    totalExpenses: "Total Expenses",
    approve: "Approve",
    reject: "Reject",
    approveExpense: "Approve expense",
    rejectExpense: "Reject expense",
    editExpenseAction: "Edit expense",
    deleteExpenseAction: "Delete expense",
    markAsPaid: "Mark as paid",
    business: "Business",
    personal: "Personal",
    businessExpenses: "Business expenses",
    personalExpenses: "Personal expenses",
    expenseEntries: "Expense entries",
    trackAndManage: "Track and manage your business expenses",
    addNewExpense: "Add New Expense",
    enterExpenseDetails: "Enter the details for the new expense.",
    updateExpenseDetails: "Update the expense details.",
    enterExpenseDescription: "Enter expense description",
    optionalNotes: "Optional notes",
    descriptionOptional: "Description (optional)",
    expenseType: "Expense Type",
    adding: "Adding...",
    saving: "Saving...",
    deleting: "Deleting...",
    saveChanges: "Save Changes",
    searchExpenses: "Search expenses...",
    vendorDescription: "VENDOR / DESCRIPTION",
    failedToLoadExpenses: "Failed to load expenses",
    expenseDeletedSuccessfully: "Expense deleted successfully",
    failedToDeleteExpense: "Failed to delete expense",
    expenseCreatedSuccessfully: "Expense created successfully",
    failedToCreateExpense: "Failed to create expense",
    expenseUpdatedSuccessfully: "Expense updated successfully",
    failedToUpdateExpense: "Failed to update expense",
    expenseMarkedAsPaid: "Expense marked as paid",
    failedToMarkAsPaid: "Failed to mark expense as paid",
    expenseApproved: "Expense approved",
    failedToApprove: "Failed to approve expense",
    expenseRejected: "Expense rejected",
    failedToReject: "Failed to reject expense",
    selectValidCategory: "Please select a valid category",
    submitFirstExpense: "Submit your first expense",
    showingOfTotal: "Showing %{visible} of %{total}",
    viewingMatchingExpenses:
      "Viewing %{filtered} matching expense(s) from %{total} loaded",
    scrollToLoadMore: "Scroll to load more expenses",
    loadingMoreExpenses: "Loading more expenses...",
    allExpensesLoaded: "All expenses loaded",
    viewExistingReceipts: "View existing receipts (%{count})",
    viewReceiptsFor: "View receipts for %{description}",
    expenseActionsFor: "Expense actions for %{description}",
    receiptPreview: "Receipt preview",
    reviewUploadedReceipts: "Review uploaded receipts for this expense.",
  },
  importModal: {
    importTitle: "Import %{title}",
    uploadFile: "Upload File",
    supportedFormats: "Supported file formats: .xls, .xlsx, .csv",
    reviewMappedFields:
      "We have identified the following columns from the file and mapped them to the required fields. Please review and confirm.",
    startImport: "Start Import",
    importingEntries: "Importing %{count} time entries",
    backgroundImportNotice:
      "This might take some time to complete. We will continue importing in the background even if you close this window and send an email to you when it is completed.",
    closeWindow: "Close Window",
    importComplete: "Import complete!",
    importSummary: "Import Summary",
    totalTimeEntries: "Total time entries",
    successfullyImported: "Successfully imported",
    failedToImport: "Failed to import",
    detailedLogSent: "We have sent a detailed log to your email.",
    importAnotherFile: "Import Another File",
    mapFields: "Map fields",
    import: "Import",
  },
  importCatalog: {
    subtitle: "Import your data into Miru",
    invoices: {
      title: "Invoices",
      description:
        "Import past invoice data from your previous invoicing tool or software",
      fields: {
        invoiceNumber: "Invoice number",
        clientName: "Client name",
        issueDate: "Issue Date",
        dueDate: "Due Date",
        amount: "Amount",
        status: "Status",
      },
    },
    timeEntries: {
      title: "Time Entries",
      description:
        "Import past time entries from your previous time tracking tool or software",
      fields: {
        employeeName: "Employee Name",
        date: "Date",
        hours: "Hours",
        status: "Status",
        client: "Client",
        project: "Project",
        description: "Description",
      },
    },
  },

  // Leave types
  leaveTypes: {
    annualLeaves: "Annual leaves",
    sickLeaves: "Sick leaves",
    maternityLeave: "Maternity leave",
    paternityLeave: "Paternity leave",
    periodLeave: "Period leave",
  },

  // Allocation periods
  allocationPeriods: {
    days: "days",
    weeks: "weeks",
    months: "months",
  },

  // Allocation frequencies
  allocationFrequencies: {
    perWeek: "Per Week",
    perMonth: "Per Month",
    perQuarter: "Per Quarter",
    perYear: "Per Year",
  },

  // Navbar
  navbar: {
    clients: "Clients",
    invoices: "Invoices",
    logout: "Logout",
    profile: "Profile",
    projects: "Projects",
    reports: "Reports",
    analytics: "Analytics",
    settings: "Settings",
    team: "Team",
    payments: "Payments",
    help: "Help",
    timeTracking: "Time Tracking",
    viewNotifications: "View Notifications",
    expenses: "Expenses",
    switchWorkspace: "Switch Workspace",
    addWorkspace: "Add Workspace",
    leavesAndHolidays: "Leaves & Holidays",
    more: "More",
    personalSettings: "Personal Settings",
    organization: "Organization",
    profileSettings: "Profile Settings",
    employmentDetails: "Employment Details",
    allocatedDevices: "Allocated Devices",
    notificationSettings: "Notification Settings",
    orgSettings: "Org. Settings",
    paymentSettings: "Payment Settings",
    leaves: "Leaves",
    holidays: "Holidays",
    workspace: "Workspace",
    active: "Active",
    createNewWorkspace: "Create New Workspace",
    selectWorkspace: "SELECT WORKSPACE",
    expandSidebar: "Expand sidebar",
    collapseSidebar: "Collapse sidebar",
    main: "Main",
    holidayCalendar: "Holiday Calendar",
    companySettings: "Company Settings",
    billing: "Billing",
    preferences: "Preferences",
    devices: "Devices",
    myLeaves: "My Leaves",
    bankAndTaxInfo: "Bank & Tax Info",
    timeTrackingDescription: "Track time across projects",
    clientsDescription: "Manage client relationships",
    projectsDescription: "Organize and track projects",
    invoicesDescription: "Create and manage invoices",
    reportsDescription: "Analytics and insights",
    paymentsDescription: "Track payment history",
    leavesDescription: "Manage time off requests",
    expensesDescription: "Track business expenses",
    auditLog: "Audit Log",
    securitySso: "Security & SSO",
    support: "Support",
  },

  // Passkeys
  passkeys: {
    noPasskeyResponse: "No passkey response received.",
    passkeysNotSupported: "Passkeys are not supported in this browser.",
    title: "Passkeys",
    addTitle: "Add a passkey for this account",
    addDescription:
      "Use Face ID, Touch ID, Windows Hello, or a hardware security key.",
    addAction: "Add passkey",
    requirementTitle: "Require passkey on sign in",
    requirementDescription:
      "After your password, Miru will require a passkey to complete sign in.",
    emptyState: "No passkeys added yet.",
    fallbackName: "Passkey",
    addedAt: "Added %{time}",
    lastUsedAt: "Last used %{time}",
    removeAction: "Remove",
    addedSuccess: "Passkey added",
    removedSuccess: "Passkey removed",
    requirementEnabled: "Passkey requirement enabled",
    requirementDisabled: "Passkey requirement disabled",
    addFailed: "Failed to add passkey.",
    removeFailed: "Failed to remove passkey.",
    updateRequirementFailed: "Failed to update passkey sign-in requirement.",
    neverUsed: "Never used",
  },

  // Organization setup
  orgSetup: {
    setupOrganization: "Setup Organization",
    companyName: "Company Name",
    enterCompanyName: "Enter company name",
    businessPhone: "Business phone",
    baseCurrency: "Base currency",
    standardPrice: "Standard price",
    fiscalYear: "Fiscal year",
    dateFormat: "Date format",
    timezone: "Timezone",
    logo: "Logo",
    saveOrgDetails: "Save org details",
    skipForNow: "Skip for now",
    orgSetupComplete: "Organization setup complete",
    selectTimezone: "Select timezone",
    selectBaseCurrency: "Select base currency",
    selectFiscalYearEnd: "Select fiscal year end",
    selectDateFormat: "Select date format",
    dragLogo: "Drag logo",
    selectFile: "Select File",
    acceptedFileFormats: "Accepted file formats: PNG, JPG, SVG.",
    fileSizeLimit: "File size should be \u2266 2MB.",
    imageResolution: "Image resolution should be 1:1.",
    workingDaysPerWeek: "Working Days (per week)",
    workingHoursPerWeek: "Working Hours (per week)",
    mostSelectedCountries: "Most selected countries",
    selectCountryGroup: "Please select",
  },
  organization: {
    updateError: "Error in updating organization details",
    basicDetails: "Basic Details",
    companyLogo: "Company Logo",
    dropLogoHere: "Drop logo here or click to upload",
    logoFormats: "JPG, PNG or GIF (max. 2MB)",
    companyName: "Company Name",
    enterCompanyName: "Enter company name",
    businessPhone: "Business Phone",
    address: "Address",
    addressLine1: "Address Line 1",
    addressLine2: "Address Line 2",
    addressLine2Placeholder: "Apartment, suite, etc. (optional)",
    country: "Country",
    selectCountry: "Select country",
    stateProvince: "State/Province",
    stateProvincePlaceholder: "State or province",
    city: "City",
    zipPostalCode: "ZIP/Postal Code",
    zipPlaceholder: "ZIP code",
    contactInformation: "Contact Information",
    businessAddress: "Business Address",
    financialConfiguration: "Financial Configuration",
    baseCurrency: "Base Currency",
    selectCurrency: "Select currency",
    businessSettings: "Business Settings",
    currency: "Currency",
    standardRate: "Standard Rate",
    fiscalYearEnd: "Fiscal Year End",
    perHour: "/hr",
    selectMonth: "Select month",
    regionalSettings: "Regional Settings",
    selectFormat: "Select format",
    workSchedule: "Work Schedule",
    workingDaysPerWeek: "Working Days per Week",
    workingHoursPerWeek: "Working Hours per Week",
    timesheetEditWindowDays: "Timesheet Edit Window (days)",
    timesheetEditWindowHint:
      "Days employees can log or edit unbilled time entries (relative to work date). Admins and owners can always edit unbilled entries.",
    timesheetEditDaysMin: "Edit window must be at least 1 day",
    timesheetEditDaysMax: "Edit window cannot exceed 365 days",
    timesheetEditDaysRequired: "Edit window is required",
    bankInformation: "Bank Information",
    bankName: "Bank Name",
    enterBankName: "Enter bank name",
    accountNumber: "Account Number",
    enterAccountNumber: "Enter account number",
    routingNumber: "Routing Number",
    enterRoutingNumber: "Enter routing number",
    swiftCode: "SWIFT Code",
    enterSwiftCode: "Enter SWIFT code",
    taxInformation: "Tax Information",
    taxId: "Tax ID",
    enterTaxId: "Enter Tax ID",
    vatNumber: "VAT Number",
    enterVatNumber: "Enter VAT number",
    gstNumber: "GST Number",
    enterGstNumber: "Enter GST number",
    ein: "EIN",
    enterEin: "Enter EIN",
    usTaxpayerId: "U.S. Taxpayer ID",
    enterUsTaxpayerId: "Enter U.S. taxpayer ID",
  },
  invoiceHistory: {
    minuteAgo: "%{count} minute ago",
    minutesAgo: "%{count} minutes ago",
    hourAgo: "%{count} hour ago",
    hoursAgo: "%{count} hours ago",
    dayAgo: "%{count} day ago",
    createdInvoice: "created invoice",
    viewedInvoice: "viewed invoice",
    updatedInvoice: "updated invoice",
    deletedInvoice: "deleted invoice",
    downloadedInvoice: "downloaded invoice",
    sentInvoice: "sent invoice",
    markedInvoicePaidManually: "marked invoice as paid manually",
    paidViaStripe: "paid via stripe",
  },
  employment: {
    validation: {
      employeeIdRequired: "Please enter employee id",
      employmentTypeRequired: "Please select employment type",
      designationRequired: "Please enter designation",
      emailRequired: "Please enter email id",
      dateOfJoiningRequired: "Please enter Date of joining",
      max20: "Maximum 20 characters are allowed",
      max40: "Maximum 40 characters are allowed",
    },
  },
  timeSlots: {
    "15Minutes": "15 minutes",
    "30Minutes": "30 minutes",
    "45Minutes": "45 minutes",
    "1Hour": "1 hour",
    "1_5Hours": "1.5 hours",
    "2Hours": "2 hours",
    "3Hours": "3 hours",
    "4Hours": "4 hours",
    "6Hours": "6 hours",
    "8Hours": "8 hours",
  },

  // Profile
  profile: {
    personalDetails: "Personal Details",
    personalInformation: "Personal Information",
    basicDetails: "Basic Details",
    contactInformation: "Contact Information",
    addressType: "Address Type",
    current: "Current",
    permanent: "Permanent",
    employmentDetails: "Employment Details",
    compensationDetails: "Compensation Details",
    devices: "Devices",
    editProfile: "Edit Profile",
    currentEmployment: "Current Employment",
    previousEmployment: "Previous Employment",
    employeeId: "Employee ID",
    designation: "Designation",
    officialEmail: "Email ID (Official)",
    employmentType: "Employment Type",
    department: "Department",
    dateOfJoining: "Date of Joining",
    dateOfResignation: "Date of Resignation",
    dateOfBirth: "Date of Birth",
    birthDatePlaceholder: "Select your birth date",
    socialProfiles: "Social Profiles",
    linkedin: "LinkedIn",
    github: "GitHub",
    firstName: "First Name",
    lastName: "Last Name",
    firstNamePlaceholder: "Enter your first name",
    lastNamePlaceholder: "Enter your last name",
    personalEmail: "Personal Email",
    personalEmailPlaceholder: "your.email@example.com",
    phoneAriaLabel: "Phone number",
    addressLine1: "Address Line 1",
    addressLine2: "Address Line 2",
    optionalSuffix: "(Optional)",
    streetAddressPlaceholder: "Street address",
    addressLine2Placeholder: "Apartment, suite, unit, etc.",
    selectCountry: "Select country",
    searchCountry: "Search country...",
    noCountryFound: "No country found.",
    statePlaceholder: "State or province",
    cityPlaceholder: "City",
    zipPostalCode: "Zip/Postal Code",
    zipPlaceholder: "12345",
    languageDescription: "Choose your preferred language for the interface.",
    account: "Account",
    security: "Security",
    userFallback: "User",
    currentPasswordPlaceholder: "Enter current password",
    newPassword: "New Password",
    newPasswordPlaceholder: "Enter new password",
    confirmPasswordPlaceholder: "Re-enter new password",
    cancelPasswordChange: "Cancel Password Change",
    profilePhoto: "Profile photo",
    profilePhotoDescription:
      "Upload a square photo for your workspace profile.",
    noAddressProvided: "No address provided",
    noEmailProvided: "No email provided",
    notProvided: "Not provided",
    notConnected: "Not connected",
    bornOn: "Born %{date}",
    lastChangedDaysAgo: "Last changed %{count} days ago",
    secure: "Secure",
    uploadPhoto: "Upload photo",
    invalidPhotoFormat:
      "Incorrect file format. Please upload a PNG, JPG, JPEG, or WEBP image.",
    invalidPhotoSize: "File size exceeded the max limit of 5MB.",
    removePhoto: "Remove photo",
    uploadPhotoFailed: "Failed to upload profile image.",
    removePhotoFailed: "Failed to remove profile image.",
    avatarUpdated: "Avatar updated successfully",
    avatarRemoved: "Avatar deleted successfully",
    adjustProfilePhoto: "Adjust profile photo",
    adjustProfilePhotoDescription:
      "Choose the part of the image you want to keep.",
    noImageSelected: "No image selected",
    savePhoto: "Apply photo",
    zoom: "Zoom",
    company: "Company",
    noPreviousEmployments: "No previous employments found",
    addPastEmployment: "+ Add Past Employment",
  },

  preferencesSettings: {
    title: "Email Preferences",
    description: "Manage your email notification settings",
    saving: "Saving...",
    saveChanges: "Save Changes",
    timesheetNotifications: "Timesheet Notifications",
    billingNotifications: "Billing Notifications",
    timesheetNotificationsDescription:
      "Manage notifications related to time tracking and timesheets",
    billingNotificationsDescription:
      "Control invoice and payment notifications",
    weeklyReminderTitle: "Weekly Timesheet Reminder",
    weeklyReminderDescription:
      "Receive weekly reminders every Monday about pending timesheet entries",
    timesheetReminderTitle: "Missing Entry Reminders",
    timesheetReminderDescription:
      "Get notified when you haven't logged time for more than 2 days",
    invoiceNotificationsTitle: "Invoice Email Notifications",
    invoiceNotificationsDescription:
      "Receive emails when invoices are created, sent, or updated",
    paymentNotificationsTitle: "Payment Email Notifications",
    paymentNotificationsDescription:
      "Get notified when payments are received or payment status changes",
    monthlyDigestTitle: "Monthly Cash Flow Digest",
    monthlyDigestDescription:
      "Receive a monthly cash flow summary with net change, money in, and money out",
    confirmUnsubscribeTitle: "Confirm Unsubscribe from All Emails",
    confirmUnsubscribeDescription:
      "Are you sure you want to unsubscribe from all email notifications? You will not receive any emails including important billing and invoice notifications.",
    confirmUnsubscribeAction: "Yes, Unsubscribe from All",
    unsubscribedTitle: "You're Unsubscribed from All Emails",
    unsubscribedDescription:
      "You are currently unsubscribed from all email notifications. You won't receive any emails from Miru.",
    resubscribeAction: "Re-enable Email Notifications",
    enabledCount: "%{count} of %{total} enabled",
    deliveryTitle: "Email Delivery Settings",
    emailAddress: "Email Address",
    deliveryDescription:
      "All notifications will be sent to this email address. To change your email, please update it in your profile settings.",
    unsubscribeTitle: "Unsubscribe",
    unsubscribeDescription:
      "If you no longer wish to receive any emails from Miru, you can unsubscribe from all notifications. This will stop all email communications including important billing and invoice notifications.",
    unsubscribeAction: "Unsubscribe from All Emails",
    badges: {
      active: "Active",
      important: "Important",
      monthly: "Monthly",
    },
  },

  automationSettings: {
    title: "Automation and CLI",
    description:
      "Use Miru from your terminal, scripts, or AI agents with the same permissions as your logged-in account. No separate automation product. No special backdoor access.",
    freeForEveryPlan: "Free for every plan",
    cards: {
      samePermissionsTitle: "Same permissions as the app",
      samePermissionsDescription:
        "The CLI only sees what the authenticated user can already access in the web app.",
      humansAndScriptsTitle: "Good for humans and scripts",
      humansAndScriptsDescription:
        "Keep simple commands for everyday tasks and let scripts or AI call the exact same interface.",
      easyToInstallTitle: "Easy to install",
      easyToInstallDescription:
        "One install command, one login, and then you can list projects, create time entries, review invoices, and more.",
    },
    commandGroups: {
      install: "Install",
      authenticateOnce: "Authenticate once",
      dailyCommands: "Daily commands",
    },
  },

  holidaysSettings: {
    year: "Year",
    publicHolidays: "Public Holidays",
    optionalHolidays: "Optional Holidays",
    holidayName: "Holiday Name",
    enterHolidayName: "Enter holiday name",
    selectDate: "Select date",
    nameCannotBeBlank: "Holiday Name can not be blank",
    optionalHolidaysHaveErrors: "Some optional holidays have missing fields.",
    addHoliday: "Add Holiday",
    addFirstHoliday: "Add First Holiday",
    addOptionalHoliday: "Add Optional Holiday",
    noPublicHolidaysConfigured: "No public holidays configured",
    noOptionalHolidaysConfigured: "No optional holidays configured",
    totalAllowed: "Total Allowed",
    enterNumber: "Enter number",
    frequency: "Frequency",
    enableOptionalHolidays: "Enable optional holidays",
    disableOptionalHolidays: "Disable optional holidays",
    optionalHolidayPolicy:
      "Employees can take up to %{count} optional holiday %{frequency}",
    optionalHolidayPolicy_plural:
      "Employees can take up to %{count} optional holidays %{frequency}",
    allowedPerEmployee: "Allowed per Employee",
    yearAtAGlance: "Year At A Glance",
    holidaySchedule: "Holiday Schedule",
    noHolidaysAddedForYear: "No holidays added for %{year} yet",
    categories: {
      public: "Public",
      optional: "Optional",
    },
    weekdays: {
      sun: "S",
      mon: "M",
      tue: "T",
      wed: "W",
      thu: "T",
      fri: "F",
      sat: "S",
    },
  },

  paymentSettingsPage: {
    backToSettings: "Back to Settings",
    title: "Payment Providers",
    description:
      "Connect payment providers to accept online payments from clients",
    errorTitle: "Error",
    errorDescription:
      "Failed to load payment settings. Please try again later.",
    stripeDescription:
      "Accept credit cards, debit cards, and popular payment methods",
    upiTitle: "UPI",
    upiDescription:
      "Show a no-fee UPI QR code on INR invoices. Clients can pay with PhonePe, Google Pay, Paytm, BHIM, or any UPI app.",
    upiId: "UPI ID",
    enterUpiId: "name@bank",
    payeeName: "Payee name",
    enterPayeeName: "Business or account name",
    merchantCategoryCode: "Merchant category code",
    merchantCategoryCodeOptional: "Optional",
    showUpiOnInvoices: "Show UPI QR on INR invoices",
    saveUpi: "Save UPI",
    savingUpi: "Saving...",
    upiSaved: "UPI settings saved.",
    upiSaveFailed: "Failed to save UPI settings.",
    invalidUpiId: "Enter a valid UPI ID, for example name@bank.",
    copyUpiId: "Copy UPI ID",
    copyPaymentLink: "Copy payment link",
    copied: "Copied",
    copyFailed: "Failed to copy.",
    freeUpiQr: "Free UPI QR",
    noGatewayFees:
      "No gateway fee. Payments are recorded manually after receipt.",
    razorpayTitle: "Razorpay",
    razorpayDescription:
      "Accept INR invoice payments through Razorpay Payment Links for UPI, Indian credit and debit cards, netbanking, wallets, and other methods enabled in your Razorpay Dashboard.",
    indiaPayments: "India payments",
    openRazorpayDashboard: "Open Razorpay",
    razorpayKeyId: "Key ID",
    razorpayKeySecret: "Key secret",
    razorpayWebhookSecret: "Webhook secret",
    razorpayWebhookUrl: "Webhook URL",
    copyWebhookUrl: "Copy webhook URL",
    copyWebhookSetup: "Copy setup",
    openRazorpayWebhooks: "Open webhooks",
    openRazorpayX: "Open RazorpayX",
    razorpayPaymentWebhookUrl: "Payment Links webhook",
    razorpayPayoutWebhookUrl: "Payouts webhook",
    razorpayPaymentWebhookEvents: "Payment Link events",
    razorpayPayoutWebhookEvents: "Payout events",
    enterKeySecret: "Enter key secret",
    enterWebhookSecret: "Enter webhook secret",
    secretAlreadySaved: "Secret already saved",
    razorpayKeyIdRequired: "Add a Razorpay key ID before enabling Razorpay.",
    razorpayKeySecretRequired:
      "Add a Razorpay key secret before enabling Razorpay.",
    razorpayPayoutDetailsRequired:
      "Add the RazorpayX account number and payout UPI ID before enabling UPI payouts.",
    linkedAccountId: "Route linked account ID",
    platformFee: "Platform fee %",
    showRazorpayOnInvoices: "Show Razorpay on INR invoices",
    routeTransfers: "Route transfers",
    payoutAccountNumber: "RazorpayX account number",
    payoutUpiId: "UPI payout ID",
    payoutPurpose: "Payout purpose",
    upiPayouts: "UPI payouts",
    queuePayouts: "Queue low-balance payouts",
    saveRazorpay: "Save Razorpay",
    savingRazorpay: "Saving...",
    razorpaySaved: "Razorpay settings saved.",
    razorpaySaveFailed: "Failed to save Razorpay settings.",
    razorpayRouteNote:
      "Cards and UPI are controlled in Razorpay Dashboard. Use the setup box above to copy the webhook URLs and event names. UPI payouts require RazorpayX account activation.",
    razorpayChecklist: {
      title: "Razorpay launch checklist",
      progress: "%{completed}/%{total} ready",
      pendingDescription:
        "Finish the required items once and every INR invoice can carry a Razorpay payment link.",
      readyDescription:
        "Razorpay can be shown on INR invoices. Add the webhook secret for automatic payment reconciliation.",
      keysTitle: "Live API keys",
      keysDescription:
        "Save the live key ID and secret from the Razorpay Dashboard.",
      invoiceTitle: "Invoice payment links",
      invoiceDescription: "Keep Razorpay enabled and visible on INR invoices.",
      webhookTitle: "Automatic reconciliation",
      webhookDescription:
        "Create Payment Links and RazorpayX payout webhooks, select the listed events, and save the same secret here.",
      payoutsTitle: "UPI payouts",
      payoutsDescription:
        "Optional. Enable only after RazorpayX is active and payout details are present.",
    },
    bankName: "Bank",
    accountNumber: "Account number",
    routingNumber: "Routing / IFSC",
    swiftCode: "SWIFT",
    connectedTo: "Connected to",
    connected: "Connected",
    enableUpi: "Enable UPI",
    quickBooksTitle: "QuickBooks Online",
    quickBooksAccounting: "Accounting sync",
    quickBooksDescription:
      "Sync Miru clients, invoices, and payments with QuickBooks Online accounting.",
    quickBooksSetupRequired: "OAuth credentials required",
    quickBooksSetupDescription:
      "Add QuickBooks OAuth credentials before connecting a company.",
    quickBooksCompany: "Company",
    quickBooksConnectedCompany: "Connected company",
    quickBooksEnvironment: "Environment",
    quickBooksRealm: "Realm ID",
    quickBooksIncomeAccount: "Income account ID",
    quickBooksArAccount: "A/R account ID",
    quickBooksDepositAccount: "Deposit account ID",
    quickBooksServiceItem: "Service item ID",
    quickBooksTaxCode: "Tax code ID",
    quickBooksConnect: "Connect QuickBooks",
    quickBooksConnecting: "Connecting...",
    quickBooksConnected: "QuickBooks connected.",
    quickBooksConnectFailed: "Failed to connect QuickBooks.",
    quickBooksDisconnected: "QuickBooks disconnected.",
    quickBooksDisconnectFailed: "Failed to disconnect QuickBooks.",
    quickBooksSaveMappings: "Save mappings",
    quickBooksSaving: "Saving...",
    quickBooksSaved: "QuickBooks mappings saved.",
    quickBooksSaveFailed: "Failed to save QuickBooks mappings.",
    quickBooksSync: "Sync workspace",
    quickBooksSyncing: "Syncing...",
    quickBooksSyncQueued:
      "QuickBooks sync queued: %{clients} clients, %{invoices} invoices, and %{payments} payments.",
    quickBooksSyncFailed: "Failed to queue QuickBooks sync. Please try again.",
    stripeAccountFallback: "Stripe Account",
    chargesEnabled: "Charges Enabled",
    connectStripe: "Connect Stripe",
    connecting: "Connecting...",
    disconnect: "Disconnect",
    disconnecting: "Disconnecting...",
    featuresTitle: "Features & Benefits",
    helpTitle: "Need Help?",
    helpDescription:
      "If you need assistance setting up payment processing or have questions about fees and capabilities:",
    viewDocumentation: "View Documentation",
    contactSupport: "Contact Support",
    disconnectDialogTitle: "Disconnect Stripe Account",
    disconnectDialogDescription:
      "Are you sure you want to disconnect your Stripe account? You will no longer be able to accept payments through Stripe until you reconnect.",
    disconnectPaymentModeDescription:
      "Are you sure you want to disconnect %{paymentMode} payment gateway? You won’t be able to receive payments through %{paymentMode} until you connect a %{paymentMode} account.",
    features: {
      secureTitle: "Secure Payments",
      secureDescription: "PCI-compliant payment processing",
      currenciesTitle: "Multiple Currencies",
      currenciesDescription: "Accept payments in 135+ currencies",
      methodsTitle: "Various Payment Methods",
      methodsDescription: "Cards, wallets, bank transfers, and more",
      setupTitle: "Instant Setup",
      setupDescription: "Start accepting payments in minutes",
    },
  },

  organizationSettingsPage: {
    actions: {
      editSettings: "Edit Settings",
    },
    sections: {
      companyProfile: "Company Profile",
      financial: "Financial",
      scheduleAndTime: "Schedule & Time",
      workingHours: "Working Hours",
    },
    fields: {
      businessPhone: "Business Phone",
      currency: "Currency",
      businessAddress: "Business Address",
      standardRate: "Standard Rate",
      fiscalYearEnd: "Fiscal Year End",
      timezone: "Timezone",
      dateFormat: "Date Format",
      workingDays: "Working Days",
    },
    status: {
      active: "Active",
    },
    defaults: {
      companyName: "Company Name",
      locationNotSet: "Location not set",
      notConfigured: "Not configured",
      noAddress: "No address configured",
      workingHours: "9:00 AM - 5:00 PM",
      workingDays: "Monday - Friday",
      timezone: "UTC",
      dateFormat: "MM/DD/YYYY",
    },
    errors: {
      loadFailed: "Failed to load organization details. Please try again.",
    },
    ratePerHour: "/ hour",
  },

  auditLog: {
    title: "Audit Log",
    description: "Review administrative and record changes in this workspace.",
    system: "System",
    empty: "No audit events match these filters.",
    loadError: "Could not load audit events. Try again or adjust the filters.",
    filters: {
      recordType: "Record type",
      allRecordTypes: "All record types",
      action: "Action",
      allActions: "All actions",
      from: "From date",
      to: "To date",
    },
    actions: {
      create: "Created",
      update: "Updated",
      destroy: "Deleted",
    },
    columns: {
      date: "Date",
      actor: "Actor",
      action: "Action",
      record: "Record",
      changes: "Changes",
    },
    pagination: {
      previous: "Previous",
      next: "Next",
      page: "Page %{page} of %{pages}",
    },
  },

  ssoSettings: {
    title: "Security & SSO",
    description: "Control how members sign in to this workspace.",
    requireSso: "Require SSO sign-in",
    requireSsoWarning:
      "Members will need to use Google or GitHub. Workspace owners keep password access to prevent lockout.",
    allowedDomains: "Allowed SSO domains",
    allowedDomainsDescription:
      "Press Enter or type a comma after each domain. Domains are saved in lowercase without @.",
    domainPlaceholder: "saeloun.com",
    membersDomainNote: "Members must sign in with an email on these domains.",
    invalidDomain: "Enter a domain with a dot and without @.",
    removeDomain: "Remove %{domain}",
    save: "Save SSO settings",
    saving: "Saving...",
    saved: "SSO settings updated.",
    loadError: "Could not load SSO settings.",
    saveError: "Could not save SSO settings.",
  },

  supportSettings: {
    title: "Support",
    priorityBadge: "Priority support",
    standardBadge: "Standard support",
    priorityDescription:
      "Priority support -- we respond within 1 business day.",
    standardDescription:
      "Send our team a support request and we will respond as soon as we can.",
    subject: "Subject",
    subjectPlaceholder: "What do you need help with?",
    message: "Message",
    messagePlaceholder: "Share the details our team needs to help.",
    send: "Send support request",
    sending: "Sending...",
    sent: "Support request sent.",
    sendError: "Could not send your support request.",
  },

  billingSettings: {
    membership: "Membership",
    currentPlan: "Current plan",
    seatUsage: "Seat usage",
    billingCadence: "Billing cadence",
    monthly: "Monthly",
    yearly: "Yearly",
    unknown: "Unknown",
    notSubscribedYet: "Not subscribed yet",
    startTrial: "Start 14-day Pro trial",
    noCreditCardRequired: "No credit card required",
    startingTrial: "Starting trial...",
    upgradeWithStripe: "Upgrade with Stripe",
    openingStripe: "Opening Stripe...",
    manageBillingInStripe: "Manage billing in Stripe",
    openingPortal: "Opening portal...",
    saveTwoMonths: "Save two months on yearly",
    heroTitle: "Pick the package that fits now. Switch later if you need more.",
    howManySeats: "How many seats do you expect to need?",
    estimatedSeats: "Estimated seats",
    recommended: "Recommended",
    estimatedProSpend: "Estimated Pro spend",
    yearlyDiscount: "Yearly discount",
    openSource: "Open source",
    annual: "Annual",
    service: "Service",
    poweredByStripe: "Powered by Stripe",
    linkCliCompatible: "Link CLI compatible",
    changePlansAnytime: "Change plans anytime",
    checkoutPoweredByStripe:
      "Checkout and subscription management are powered by Stripe.",
    linkCliDescription:
      "Agents can request one-time Link CLI virtual card credentials and complete the same Stripe Checkout without exposing saved card details.",
    noSalesCall:
      "No sales call for Pro. Cancel or change plans in Stripe anytime.",
    reportsAndAnalytics: "Reports and analytics",
    customAnnual: "Custom annual",
    seatsUsed: "%{used}/%{total} seats used",
    seatsUsedWithoutLimit: "%{used} seats used",
    savePerYear: "Save $%{amount}/yr",
    effectiveMonthlyPricing: "About $%{amount}/mo effective pricing",
    cancelOrUpgradeAnytime: "Cancel or upgrade any time in Stripe",
    planCadence: {
      monthly: "Billed month to month",
      yearlySavings: "Save 2 months per seat",
    },
    featureGate: {
      reportsTitle: "Reports is a Pro feature",
      reportsDescription:
        "Upgrade to Pro to unlock Reports, analytics, and exports.",
      analyticsTitle: "Analytics is a Pro feature",
      analyticsDescription:
        "Upgrade to Pro to unlock forecasts, performance insights, and exports.",
      auditTitle: "Audit Log is a Pro feature",
      auditDescription:
        "Upgrade to Pro to review administrative and record changes.",
      ssoTitle: "Security & SSO is a Pro feature",
      ssoDescription:
        "Upgrade to Pro to enforce SSO and restrict workspace email domains.",
      seatsTitle: "You've reached your free plan's team limit",
      seatsDescription:
        "Upgrade to Pro to add unlimited team members to this workspace.",
    },
    alerts: {
      subscriptionUpdatedTitle: "Subscription updated",
      subscriptionUpdated: "Your plan was updated in Stripe successfully.",
      finalizing: "Finalizing your subscription…",
      finalizingDelayed:
        "Payment received — your Pro access will appear shortly. Refresh in a minute.",
      checkoutCancelled: "Checkout cancelled",
      noSubscriptionChanges: "No changes were made to your subscription.",
      unableToLoad: "Unable to load billing details",
      proTrialActive: "Pro trial active",
      proTrialActiveUntil: "Your workspace has Pro access until %{date}.",
      proTrialEnded: "Pro trial ended",
      proTrialEndedDescription:
        "Your workspace no longer has Pro access. Upgrade in Stripe to restore it.",
      subscriptionScheduledToCancel: "Subscription scheduled to cancel",
      subscriptionScheduledToCancelOn:
        "Your Pro access remains active until %{date}.",
      seatLimitReached: "Seat limit reached",
      seatLimitReachedDescription:
        "Upgrade in Stripe to add more than 3 members to this workspace.",
      clientPortalUsersTitle: "Client portal users included in seat count",
      clientPortalUsersDescription:
        "%{count} client portal user(s) have login access and count toward your workspace's seat usage, but they are not billed — only team members are charged. Team members are managed on the Team page.",
    },
    errors: {
      unableToOpenStripeCheckout: "Unable to open Stripe checkout",
      unableToOpenStripeBillingPortal: "Unable to open Stripe billing portal",
      unableToStartProTrial: "Unable to start your Pro trial",
    },
    recommendations: {
      proTitle: "Pro is the right fit",
      proDescription:
        "For growing teams, Pro gives you SSO, finance visibility, and enough room to scale without enterprise overhead.",
      enterpriseTitle: "Talk to us about Enterprise",
      enterpriseDescription:
        "Larger teams usually need procurement support, admin controls, and a smoother rollout. Start with Pro or move straight to Enterprise.",
    },
    highlights: {
      seatsTitle: "More seats without admin pain",
      seatsDescription:
        "Move past the 3-seat limit and keep onboarding simple.",
      ssoTitle: "SSO and stronger controls",
      ssoDescription: "Give growing teams secure access without extra tools.",
      financeTitle: "Finance visibility that stays calm",
      financeDescription:
        "Know revenue, billing cadence, and team usage without extra setup.",
    },
    planDescriptions: {
      pro: "Pro adds reports, SSO, more seats, and calmer admin controls without enterprise overhead.",
      enterprise:
        "Procurement-friendly contracts, advanced controls, and support for larger teams that need security review.",
      hostedEnterprise:
        "We host, upgrade, back up, and support Miru for you on a dedicated setup.",
    },
    planBullets: {
      pro: {
        trial: "14-day free trial — no credit card required",
        sso: "SSO, advanced reporting, stronger admin controls",
        fit: "Best fit for agencies and growing teams",
      },
      enterprise: {
        contracts: "Procurement-friendly contracts",
        onboarding: "Security review and onboarding support",
        compliance: "For larger teams with approval and compliance needs",
      },
      hosted: {
        setup: "Dedicated managed setup",
        operations: "We handle upgrades, backups, and support",
        fit: "For teams that want Miru fully operated for them",
      },
    },
    heroDescription:
      "Every workspace starts with a 14-day Pro trial. Upgrade when the team is ready, or let us run Miru for you. Pro stays inexpensive, yearly saves real money, and billing stays simple because checkout and subscription management are powered by Stripe.",
    seatEstimatorDescription:
      "Use this to estimate your Pro spend and decide whether monthly or yearly makes more sense.",
    yearlyDiscountDescription:
      "Two free months per seat compared with monthly pricing.",
    checkoutDescription:
      "Start the trial without a sales process, upgrade when you are ready, and manage billing yourself whenever you need.",
    plans: {
      unknown: "Unknown",
      freePro: "Free Pro",
      proTrial: "Pro Trial",
      trialExpired: "Trial expired",
      noPlan: "No active plan",
      paid: "Paid",
      enterprise: "Enterprise",
      hostedEnterprise: "Hosted Enterprise",
    },
    table: {
      feature: "Feature",
      bestFor: "Best for",
      selfHostedTeams: "Self-hosted teams getting started",
      growingServiceTeams: "Growing service teams that need controls",
      largeOrgs: "Larger orgs with security and procurement needs",
      managedTeams: "Teams that want Miru managed for them",
      timeTracking: "Time tracking",
      invoicesAndPayments: "Invoices and payments",
      reportsAndDashboards: "Reports and dashboards",
      sso: "SSO",
      auditAndAdminControls: "Audit and admin controls",
      support: "Support",
      included: "Included",
      notIncluded: "Not included",
      dashboardOnly: "Dashboard only",
      reportsAndAnalytics: "Reports and analytics",
      community: "Community",
      priorityEmail: "Priority email",
      priorityOnboarding: "Priority + onboarding",
      managedOnboarding: "Managed service + onboarding",
    },
  },

  twoFactor: {
    title: "Authenticator App 2FA",
    addTitle: "Add an authenticator app",
    addDescription:
      "Use Google Authenticator, 1Password, Bitwarden, Authy, or any TOTP-compatible app.",
    setupAction: "Set up 2FA",
    finishTitle: "Finish authenticator setup",
    finishDescription:
      "Add this key to your authenticator app, then enter the current 6-digit code to enable 2FA.",
    manualEntryKey: "Manual entry key",
    verificationCode: "Verification code",
    verificationCodePlaceholder: "123456",
    enableAction: "Enable 2FA",
    resetKeyAction: "Reset key",
    enabledTitle: "Authenticator app protection is on",
    enabledDescription:
      "You will need an authenticator code after your password when you sign in.",
    recoveryCodesAvailable: "%{count} recovery codes available",
    regenerateRecoveryCodes: "Regenerate recovery codes",
    disableAction: "Disable 2FA",
    saveRecoveryCodes: "Save these recovery codes",
    saveRecoveryCodesDescription:
      "Each code works once. Store them somewhere safe.",
    setupReadySuccess: "Authenticator app setup is ready",
    enabledSuccess: "Authenticator app enabled",
    disabledSuccess: "Authenticator app disabled",
    regeneratedSuccess: "Recovery codes regenerated",
    setupFailed: "Failed to start 2FA setup.",
    enableFailed: "Failed to enable authenticator app.",
    disableFailed: "Failed to disable 2FA.",
    regenerateFailed: "Failed to regenerate recovery codes.",
  },

  // Leave Management
  leaveManagement: {
    leaveBalance: "Leave Balance",
    applyLeave: "Apply Leave",
    leaveHistory: "Leave History",
    leaveDetails: "Leave Details",
    startDate: "Start Date",
    endDate: "End Date",
    reason: "Reason",
    enterReason: "Enter reason",
    noLeavesApplied: "No leaves applied yet",
    approve: "Approve",
    reject: "Reject",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    cancelled: "Cancelled",
    availableLeaves: "Available Leaves",
    usedLeaves: "Used Leaves",
    timeAwayUsed: "Time away used",
    leaveRemaining: "Leave remaining",
    optionalHolidays: "Optional holidays",
    publicHolidays: "Public holidays",
    zeroUsed: "0 used",
    leaveCalendar: "Leave calendar",
    trackLeaveUsage:
      "Track leave and holiday usage month by month for %{year}.",
    selectDayToInspect:
      "Select a day to inspect leave details and holiday usage.",
    nothingBooked: "Nothing booked",
    nothingBookedForDate: "Nothing booked for this date.",
    recordedTimeAway: "Recorded time away on this day",
    noLeaveOrHoliday: "No leave or holiday marked for this day",
    timeOff: "Time off",
    customLeave: "custom leave",
    leave: "leave",
    nationalHoliday: "National Holiday",
    optionalHoliday: "Optional Holiday",
    leaveTypeUtilized: "%{name} Utilized",
    leaveTypeAvailable: "%{name} Available",
    outOf: "out of",
    thisQuarter: "this quarter",
    thisYear: "this year",
    thisMonth: "this month",
    thisWeek: "this week",
    summaryLabel: "Leave summary",
    summaryDescription:
      "See available leave, time already taken, and holiday usage for the selected year in one place.",
    balanceUntil: "Balance Until %{date}",
  },

  notificationPreferences: {
    emailNotifications: "Email Notifications",
    manageDescription: "Manage your email notification preferences",
    weeklyEmailReminder: "Weekly Email Reminder",
    weeklyEmailReminderDescription:
      "Receive weekly email reminders about timesheet entries and project updates",
    noUserData: "No user data available",
    loginPrompt: "Please log in to manage notification preferences",
  },

  devices: {
    addDevices: "Add Devices",
    editDevices: "Edit Devices",
    device: "Device",
    unknownDevice: "Unknown Device",
    serial: "Serial:",
    deviceType: "Device Type",
    selectDeviceType: "Select device type",
    modelName: "Model/Name",
    serialNumber: "Serial Number",
    memory: "Memory (RAM)",
    processor: "Processor",
    graphics: "Graphics",
    graphicsCard: "Graphics Card",
    storage: "Storage",
    modelNamePlaceholder: "e.g., MacBook Pro 16-inch",
    serialNumberPlaceholder: "e.g., C02XX1234567",
    memoryPlaceholder: "e.g., 16GB DDR4",
    processorPlaceholder: "e.g., Intel Core i7-10750H",
    graphicsPlaceholder: "e.g., NVIDIA GeForce RTX 3060",
    storagePlaceholder: "e.g., 512GB SSD",
    addAnotherDevice: "Add Another Device",
    addAnotherDeviceDescription: "Click to add a new device to your inventory",
    deviceSummary: "Device Summary",
    totalDevices: "Total Devices",
    notSpecified: "Not specified",
    noDevicesFound: "No devices found",
    newDevice: "New Device",
    deviceTypeRequired: "Device type is required",
    modelNameRequired: "Model/Name is required",
    serialNumberRequired: "Serial number is required",
    requiredFieldsError: "Complete the required device fields before saving",
    unsavedChangesPrompt:
      "You have unsaved changes. Are you sure you want to cancel?",
  },

  // Subscriptions / Plan Details
  subscriptions: {
    currentPlan: "Current Plan",
    upgradePlan: "Upgrade Plan",
    manageBilling: "Manage Billing",
    billingHistory: "Billing History",
    planDetails: "Plan Details",
    numberOfTeamMembers: "Number of Team Members:",
    plan: "Plan",
    basicPlan: "Basic Plan",
    basicPlanDescription:
      "Basic plan includes all features. This is a one-time charge.",
    chargedOnce: "charged once",
    addOns: "Add-Ons",
    oneTeamMember: "1 team member",
    chargedEveryMonth: "charged every month",
    basicPlanPerUser:
      "Basic plan comes with additional %{rate}$ per user per month.",
    plusTaxes: "plus taxes",
    reviewAndPay: "REVIEW AND PAY",
  },

  // Misc
  switchToMode: "Switch to %{mode} mode",
  light: "Light",
  dark: "Dark",
  showPassword: "Show password",
  hidePassword: "Hide password",
  selectOption: "Select",
  editLabel: "Edit",
  noPasskeyResponse: "No passkey response received.",
  passkeysNotSupported: "Passkeys are not supported in this browser.",

  // Table headers (common)
  tableHeaders: {
    invoiceNo: "INVOICE NO.",
    invoiceNumber: "INVOICE NUMBER",
    issueDate: "ISSUE DATE",
    issueDateDueDate: "ISSUE DATE/ DUE DATE",
    dueDate: "DUE DATE",
    amount: "AMOUNT",
    status: "STATUS",
    statusAmount: "STATUS/ AMOUNT",
    name: "NAME",
    description: "DESCRIPTION",
    date: "DATE",
    time: "TIME",
    notes: "NOTES",
    user: "USER",
    salary: "SALARY",
    role: "ROLE",
    type: "TYPE",
  },

  // Relative dates
  nextDay: "Next %{day}",
  lastDay: "Last %{day}",

  // Duration formatting
  durationMinutes: "%{mins}m",
  durationHours: "%{hours}h",
  durationHoursMinutes: "%{hours}h %{mins}m",

  // Common extras
  common: {
    loadingLatestVersion: "Loading latest version...",
    updatingApplication: "Updating application",
    newVersionAvailable: "A new version is available",
    deployReloadPrompt:
      "We could not load the latest app files automatically. Refresh once to continue with the updated build.",
    reloadApplication: "Reload application",
    pageLoadFailedRefresh: "This page failed to load. Refresh and try again.",
    retry: "Retry",
    pageUnavailable:
      "This page is unavailable or the link is no longer valid for your workspace.",
    goToDashboard: "Go to dashboard",
    language: "Language",
    loading: "Loading...",
    saving: "Saving...",
    failedToChangeLanguage: "Failed to change language",
    searchLanguages: "Search languages...",
    noLanguagesFound: "No languages found",
  },

  // Auth sign in (deeply nested for upstream compatibility)
  auth: {
    signIn: {
      title: "Sign in to your workspace",
      description:
        "Track work, send invoices, and keep cash flow clear from one place.",
      continueWithGoogle: "Continue with Google",
      continueWithGitHub: "Continue with GitHub",
      orUseEmail: "or use email",
      email: "Email",
      password: "Password",
      submit: "Sign in",
      forgotPassword: "Forgot password?",
      noAccount: "Don't have an account? ",
      signUp: "Sign up",
      privacy: "Privacy",
      terms: "Terms",
      loginFailed: "Login failed. Please try again.",
      welcomeBack: "Welcome back!",
      waitingForPasskey: "Waiting for passkey...",
      passkeyPrompt: "Use your passkey to sign in",
      totpTitle: "Two-Factor Authentication",
      totpPrompt: "Enter the code from your authenticator app",
      totpDescription: "Open your authenticator app and enter the 6-digit code",
      totpCode: "Authentication code",
      verifyAndSignIn: "Verify and sign in",
      recoveryCode: "Use a recovery code instead",
      back: "Back",
    },
    signUp: {
      title: "Create your workspace",
      description:
        "Start your free 14-day Pro trial — no credit card required. Clients, projects, invoices, and payments in one clear operating system.",
      continueWithGoogle: "Continue with Google",
      continueWithGitHub: "Continue with GitHub",
      orUseEmail: "or use email",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      passwordCriteria:
        "At least 8 characters with one uppercase, one lowercase, and one number",
      submit: "Create account",
      alreadyHaveAccount: "Already have an account? ",
      signIn: "Sign in",
      agreePrefix: "By signing up, you agree to our ",
      termsOfService: "Terms of Service",
      and: " and ",
      privacyPolicy: "Privacy Policy",
    },
    slides: {
      dashboard: {
        title: "Company pulse",
        description:
          "See revenue, active projects, and team momentum without digging for it.",
      },
      invoices: {
        title: "Billing command",
        description:
          "Keep drafts, overdue balances, and paid work in the same place.",
      },
      timeTracking: {
        title: "Clear weekly flow",
        description:
          "Week-by-week time entry stays current without turning into busywork.",
      },
      payments: {
        title: "Cash ledger",
        description:
          "Accept Stripe cards or free UPI QR payments, then keep every payment in one ledger.",
      },
    },
    paymentBadges: {
      upiQr: "Free UPI QR",
      stripe: "Stripe cards",
    },
    validation: {
      emailRequired: "Email is required",
      invalidEmail: "Invalid email address",
      passwordRequired: "Password is required",
      passwordComplexity:
        "Password must be at least 8 characters with uppercase, lowercase, and number",
      passwordSpace: "Password cannot contain spaces",
      confirmPasswordRequired: "Confirm password is required",
      passwordsMustMatch: "Passwords must match",
      firstNameRequired: "First name is required",
      firstNameInvalid: "First name must contain only letters",
      firstNameMax: "First name must be 20 characters or less",
      lastNameRequired: "Last name is required",
      lastNameInvalid: "Last name must contain only letters",
      lastNameMax: "Last name must be 20 characters or less",
      acceptTerms: "You must accept the terms",
      nameRequired: "Name cannot be blank",
      max30: "Maximum 30 characters are allowed",
      invalidEin: "EIN must use NN-NNNNNNN format",
      phoneMin2Digits: "Phone number must contain at least 2 digits",
      phoneMax15Digits: "Phone number cannot exceed 15 digits",
      validBusinessPhone: "Please enter a valid business phone number",
      addressLineRequired: "Address line cannot be blank",
      addressLine1Required: "Address Line 1 cannot be blank",
      max50: "Maximum 50 characters are allowed",
      countryRequired: "Country cannot be blank",
      stateRequired: "State cannot be blank",
      cityRequired: "City cannot be blank",
      zipcodeRequired: "Zipcode cannot be blank",
      zipcodeLineRequired: "Zipcode line cannot be blank",
      invalidZipcode: "Please enter a valid zipcode",
      max10: "Maximum 10 characters are allowed",
      amountMustBeNumber: "Amount must be a number",
      amountMustBePositive: "Please enter a larger amount",
      rateRequired: "Rate cannot be blank",
      workingHoursRequired: "Working hours cannot be blank",
      workingDaysRequired: "Working days cannot be blank",
      firstNamePrompt: "Please enter first name",
      lastNamePrompt: "Please enter last name",
      addressLine1Prompt: "Please enter address line 1",
      countryPrompt: "Please enter country",
      statePrompt: "Please enter state",
      cityPrompt: "Please enter city",
      zipcodePrompt: "Please enter zipcode",
      validEmailPrompt: "Please enter valid email",
      dateOfBirthFuture: "Date of birth cannot be in the future",
      mobileMin2Digits: "Mobile number must contain at least 2 digits",
      mobile15Digits: "Mobile number cannot exceed 15 digits",
      passwordPrompt: "Please enter password",
      currentPasswordPrompt: "Please enter current password",
      passwordComplexityStrict:
        "Must contain at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character",
      currencyRequired: "Currency cannot be blank",
    },
    miruLogo: "Miru",
    heroTitle: "One place for time, invoices, and payments",
    heroDescription:
      "Keep the day clear, keep billing moving, and keep cash visible.",
    companyPulse: "Company pulse",
    billingCommand: "Billing command",
    clearWeeklyFlow: "Clear weekly flow",
    cashLedger: "Cash ledger",
    signOut: "Sign out",
    signInToWorkspace: "Sign in to your workspace",
    createYourWorkspace: "Create your workspace",
    signInDescription:
      "Track work, send invoices, and keep cash flow clear from one place.",
    signUpDescription:
      "Set up clients, projects, invoices, and payments in one clear operating system.",
    firstName: "First Name",
    lastName: "Last Name",
    password: "Password",
    confirmPassword: "Confirm Password",
    forgotPassword: "Forgot password?",
    enterRegisteredEmail: "Enter your registered email ID",
    resetPassword: "Reset Password",
    resetPasswordInstructions:
      "Enter the email address associated with your account and we'll send you a link to reset your password.",
    sendResetLink: "Send Reset Link",
    backToLogin: "Back to login",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    rememberMe: "Remember me",
    totpPlaceholder: "ABCD-EFGH",
    noAuthTokenReceived: "No authentication token received",
    slideDashboardDescription:
      "See revenue, active projects, and team momentum without digging for it.",
    slideInvoicesDescription:
      "Keep drafts, overdue balances, and paid work in the same place.",
    slideTimeTrackingDescription:
      "Week-by-week time entry stays current without turning into busywork.",
    slidePaymentsDescription:
      "Every payment lands in one ledger with method, status, and source.",
    slideShowPrefix: "Show",
    continueWithGoogle: "Continue with Google",
    continueWithGithub: "Continue with GitHub",
    orUseEmail: "or use email",
    verifyWithAuthenticator: "Verify with your authenticator app",
    authenticatorInstructions:
      "Enter the 6-digit code from your authenticator app, or use a recovery code.",
    authenticatorCode: "Authenticator code",
    recoveryCode: "Recovery code",
    verifyAndSignIn: "Verify and sign in",
    completePasskeyVerification:
      "Complete passkey verification to finish signing in.",
    enterAuthenticatorCode:
      "Enter your authenticator code to finish signing in.",
    invalidVerificationCode: "Invalid verification code.",
    privacy: "Privacy",
    terms: "Terms",
    createAccount: "Create account",
    passwordCriteria:
      "Min. 8 characters, 1 uppercase, 1 lowercase, 1 number and 1 special character",
    agreeToTerms: "I agree to the",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    and: "and",
    welcomeBack: "Welcome back!",
    loginFailed: "Login failed. Please try again.",
    waitingForPasskey: "Waiting for passkey...",
  },

  // Navigation (upstream uses nav.* prefix)
  nav: {
    dashboard: "Dashboard",
    timeTracking: "Time Tracking",
    clients: "Clients",
    projects: "Projects",
    team: "Team",
    invoices: "Invoices",
    reports: "Reports",
    payments: "Payments",
    leavesAndHolidays: "Leaves & Holidays",
    expenses: "Expenses",
    settings: "Settings",
    logout: "Logout",
  },

  // Sidebar (upstream uses sidebar.* prefix)
  sidebar: {
    main: "Main",
    personalSettings: "Personal Settings",
    companySettings: "Company Settings",
    profile: "Profile",
    devices: "Devices",
    organization: "Organization",
    billing: "Billing",
    paymentSettings: "Payment Settings",
    holidayCalendar: "Holiday Calendar",
    myLeaves: "My Leaves",
    bankTaxInfo: "Bank & Tax Info",
    expand: "Expand sidebar",
    collapse: "Collapse sidebar",
  },

  // Settings labels (upstream uses settings.labels/categories)
  settings: {
    settings: "Settings",
    profileSettings: "Profile Settings",
    organizationSettings: "Organization Settings",
    paymentSettings: "Payment Settings",
    profilePicture: "Profile picture",
    changePassword: "Change password",
    currentPassword: "Current password",
    password: "Password",
    confirmPassword: "Confirm password",
    billing: "Billing",
    integrations: "Integrations",
    leaves: "Leaves",
    import: "Import",
    general: "General",
    profile: "Profile",
    organization: "Organization",
    payment: "Payment",
    allocateLeaves: "Allocate Leaves",
    customLeaves: "Custom Leaves",
    addCustomLeave: "Add Custom Leave",
    editCustomLeave: "Edit Custom Leave",
    leaveType: "Leave Type",
    enterLeaveType: "Enter leave type",
    allocationValue: "Allocation Value",
    allocationPeriod: "Allocation Period",
    allocationFrequency: "Allocation Frequency",
    labels: {
      profile: "Profile",
      employment: "Employment",
      devices: "Devices",
      notifications: "Notifications",
      preferences: "Preferences",
      organization: "Organization",
      billing: "Billing",
      auditLog: "Audit Log",
      securitySso: "Security & SSO",
      support: "Support",
      payment: "Payment",
      holidays: "Holidays",
      leaves: "Leaves",
      automation: "Automation",
      bankInfo: "Bank & Tax Info",
    },
    categories: {
      personal: "Personal",
      organization: "Organization",
    },
  },

  // Dashboard extras (upstream uses dashboard.stats/charts/etc)
  dashboard: {
    dashboard: "Dashboard",
    overdue: "OVERDUE",
    outstanding: "OUTSTANDING",
    totalHours: "TOTAL HOURS",
    revenueOverview: "Revenue Overview",
    there: "there",
    companyPulse: "COMPANY PULSE",
    welcomeBack: "Welcome back, %{name}",
    recentActivity: "Recent Activity",
    workspaceActivity: "Workspace Activity",
    activityDescription:
      "Latest invoices, payments, and team updates across your workspace",
    employeeActivityDescription: "Your recent time entries and project updates",
    noRecentActivityYet: "No recent activity yet",
    loadMore: "Load more",
    caughtUp: "All caught up!",
    yearToDate: "Year to date",
    quarterToDate: "Quarter to date",
    monthToDate: "Month to date",
    weekToDate: "Week to date",
    revenue: "Revenue",
    activeProjects: "Active Projects",
    currentlyActive: "Currently active",
    noRecentActivity: "No recent activity",
    teamSize: "Team Size",
    teammates: "Teammates",
    hoursTracked: "Hours Tracked",
    assignedProjects: "Assigned Projects",
    projectsYouCanWorkOn: "Projects you can work on",
    totalInvoiced: "Total Invoiced",
    openInvoices: "Open Invoices",
    awaitingPayment: "Awaiting payment",
    paidInvoices: "Paid Invoices",
    alreadySettled: "Already settled",
    paymentsReceived: "Payments Received",
    employeeGuidance:
      "Track your week, submit accurate entries, and keep work moving.",
    bookKeeperGuidance:
      "Review incoming payments, reconcile invoices, and keep cash flow clear.",
    clientGuidance:
      "Check invoice status and payment history for your account.",
    defaultGuidance: "Revenue, projects, and team momentum at a glance.",
    allCaughtUp: "You're all caught up",
    timeframe: {
      week: "This Week",
      month: "This Month",
      quarter: "This Quarter",
      year: "Current Financial Year",
    },
    stats: {
      revenue: "Revenue",
      totalInvoiced: "Total Invoiced",
      openInvoices: "Open Invoices",
      paidInvoices: "Paid Invoices",
      paymentsReceived: "Payments Received",
      awaitingPayment: "Awaiting Payment",
      alreadySettled: "Already settled",
      hoursTracked: "Hours Tracked",
      currentlyActive: "Currently active",
      activeProjects: "Active Projects",
      assignedProjects: "Assigned Projects",
      projectsYouCanWorkOn: "Projects you can work on",
      teammates: "Teammates",
      teamSize: "Team Size",
      noRecentActivity: "No recent activity",
    },
    charts: {
      revenueMomentumTitle: "Revenue Momentum",
      revenueMomentumDescription:
        "Monthly revenue trend for the current financial year",
      revenueTrendEyebrow: "REVENUE TREND",
      revenueLeadersTitle: "Revenue Leaders",
      revenueLeadersDescription: "Top clients by revenue contribution",
      topCustomersEyebrow: "TOP CUSTOMERS",
      ofTotal: "%{percentage} of total",
      noRevenue: "No revenue data available",
    },
    roleGuidance: {
      employee: "Track your time and manage your projects",
      bookKeeper: "Review invoices, payments, and financial reports",
      client: "View your invoices and payment history",
      default: "Manage your workspace",
    },
  },
};

export default en;
